document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.inputOnChange();

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();

    const previousValue = this.input.value;
    if(event.target.nodeName != "BUTTON") {


      event.target.closest('.quantity__button').name === 'plus' ? this.input.stepUp() : this.input.stepDown();

      if( event.target.closest('.product-form__quantity') ) {

        this.priceUpdateOnBtnChange(event);
      }

    } else {

      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
      if( event.target.closest('.product-form__quantity') ) {
        // this.priceUpdateOnBtnChange(event);
      }
    }
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
  //inputon change
  inputOnChange() {
    this.input.addEventListener('change',(event)=>{
      this.resetCustomizedPrice();
      this.priceUpdateOnBtnChange(event);
    })
  }
  // change button price values
  priceUpdateOnBtnChange(event) {

    const parentDiv = event.target.closest('.product__info-container');
    if( parentDiv ) {
      const incrementValue = parentDiv.querySelector('quantity-input input').value;
      const topParent = parentDiv.closest('.product__info-wrapper');
      const priceEl = parentDiv.querySelector('[data-price="price__js"]').querySelector('.price__sale .price-item--sale').innerHTML;
      const totalPrice = incrementValue * priceEl.replace('$','');
      if( topParent.querySelector('.product-form__buttons .price--btn .price-item') ) {
        topParent.querySelector('.product-form__buttons .price--btn .price-item').innerHTML = `$${totalPrice}`;
      }
      // document.querySelector('#addToRegistry').setAttribute('data-price',`${totalPrice}`);
      // document.querySelector('#addToRegistry').setAttribute('data-quantity',`${incrementValue}`);
    }

  }

  resetCustomizedPrice()
  {
    if( document.querySelector('.pdp_pww_block, .pdp_fwp_block') ) {
      document.querySelectorAll('.pdp_pww_block, .pdp_fwp_block').forEach(pdpPwwBlock => {
        if(pdpPwwBlock.getAttribute('data-sync') == 'true')
        {
        }
        pdpPwwBlock.querySelectorAll('.checked[data-id="product-pdp_pww"]').forEach(checkBox => {
          let clickEvent = new Event('click');
          checkBox.dispatchEvent(clickEvent);
        });
      });
    }
    if( document.querySelector(".pdpPww-total-price__js").querySelector('.renderPrice') ) {
      const mainProductSection = document.querySelector('.product__info-wrapper');
      let priceSection = document.querySelector(".pdpPww-total-price__js");
      const incrementValue = mainProductSection.querySelector('quantity-input input').value;
      let htmlPriceElm = mainProductSection.querySelector('[data-price="price__js"]');
      const yourSalesPrice = htmlPriceElm.querySelector('.price__sale .price-item--sale').innerHTML.replace('$','').trim();
      const yourRegularPrice = htmlPriceElm.querySelector('.price__sale .price-item--regular').innerHTML.replace('$','').trim();
      var savingPriceBlock = priceSection.querySelector(".price-saved-badge");

      const totalSalesPrice = incrementValue * yourSalesPrice;
      const totalRegularPrice = incrementValue * yourRegularPrice;

      priceSection.querySelector('.renderPrice').querySelector('.price__regular .price-item--regular').innerHTML = '$'+totalRegularPrice.toFixed(2).replace(/\.00$/, "");
      priceSection.querySelector('.renderPrice').querySelector('.price__sale .price-item--regular').innerHTML = '$'+totalRegularPrice.toFixed(2).replace(/\.00$/, "");
      priceSection.querySelector('.renderPrice').querySelector('.price__sale .price-item--sale').innerHTML = '$'+totalSalesPrice.toFixed(2).replace(/\.00$/, "");

      if( yourSalesPrice != yourRegularPrice ) {
        priceSection.querySelector('.renderPrice').querySelector('.price__sale .price-item--sale').innerHTML = '$'+totalSalesPrice.toFixed(2).replace(/\.00$/, "");
        priceSection.querySelector('.renderPrice').querySelector('.price__sale .price-item--regular').innerHTML = '$'+totalRegularPrice.toFixed(2).replace(/\.00$/, "");

        if (savingPriceBlock) {
          savingPriceBlock.innerHTML = "$" + (totalRegularPrice - totalSalesPrice).toFixed(2).replace(/\.00$/, "") + " Savings";
          savingPriceBlock.classList.remove('d-none');
        }
      } else {
        if (savingPriceBlock) {
          savingPriceBlock.classList.add('d-none');
        }
      }
    }

    /**For price section*/
    if( document.querySelector('.sticky-atc, .subscription-sticky-atc') ) {
      let stickyBottomTotalPrice = document.getElementById('stickyBottomTotalPrice');
      let pdpPwwtotalPrice = document.querySelector('.pdpPww-total-price__js');
      if (stickyBottomTotalPrice != null && pdpPwwtotalPrice != null){
          let pdpTotalPrice = pdpPwwtotalPrice.innerHTML;
          stickyBottomTotalPrice.innerHTML = pdpTotalPrice;
      }
    }

    if(document.querySelectorAll(".pdpPww-total-price-clone__js").length > 0){
      document.querySelectorAll(".pdpPww-total-price-clone__js").forEach((pdpPwwtotalPriceClone) => {
        let pdpPwwtotalPrice = document.querySelector(
          ".pdpPww-total-price__js"
        );
        if (pdpPwwtotalPriceClone && pdpPwwtotalPrice != null) {
          pdpPwwtotalPriceClone.innerHTML = pdpPwwtotalPrice.innerHTML;;
        }
        if(document.querySelector("bundled-product"))
          pdpPwwtotalPriceClone.querySelector("span.your-total-text").textContent = "Bundle Total:";
      });
    }
  }

}

customElements.define('quantity-input', QuantityInput);

class VariantStarts extends HTMLElement {
  constructor() {
    super();
    this.updateOptions();
    this.updateMasterId();
    //this function is used to check if that variant has the badge enabled or not
    //this.enableBadge();
    // this.checkKitMessage(this.currentVariant);
    this.bundleKitMessages(true);
    this.hideVariant(this.currentVariant);
    this.bundlePriceChange();
    this.updateShippingInfo();
    this.updateSubscriptionBox();
    // const mainVariantSection = document.querySelector("bundled-product");
    // if (mainVariantSection) {
    //   // Use arrow function to preserve 'this' context
    //   mainVariantSection.addEventListener("change", () => {
    //     const isCustom = this.isCustomized() === true;
    //     if (isCustom) {
    //       console.log('i am here');

    //     }
    //   });
    // }

    setTimeout(() => {
      this.initGallery();
    }, 1000);

    this.thumbnailData = document.querySelectorAll(".thumbnail-list li");
    this.mediaData = document.querySelectorAll(".product__media-list li");
    this.addEventListener("change", this.onVariantChange);
    this.setAttribute("data-variant-id", this.currentVariant.id);

    this.toggleAddButton(
      !this.currentVariant.available,
      window.variantStrings.soldOut
    );

    this.toogleOOSMessage(!this.currentVariant.available);
    this.toggleBackorderMessage(!this.currentVariant.available);
    if(document.querySelector('bundled-product'))
      this.isProductHasBundle = document.querySelector('bundled-product');
  }



  initGallery() {
    if (this.currentVariant) {
      this.updateMedia();
      if(document.querySelector('bundled-product')){
        document.getElementById("isAlreadyTriggered").value="false";
        this.changeBundleImage();
      }
    }
    // console.log(this.currentVariant);
  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    // this.checkKitMessage(this.currentVariant,e);
    this.bundleKitMessages();

    this.bundlePriceChange();

    //this function is used to check if that variant has the badge enabled or not
    this.enableBadge();
    //check if first_active__js is present or not
    let hideFirst = false;
    if(this.querySelector('.first_active__js')){
      hideFirst = true;
    }
    // console.log("Current variant id: "+this.currentVariant.id);
    this.hideVariant(this.currentVariant,hideFirst);
    this.forcedSetActiveInSecondOption(e);

    //to execute the below function there must have the current variant if not there might be some js issue
    if( this.currentVariant )
    {
      this.toggleAddButton(true, "", false);
      this.toogleOOSMessage(false, true);
      this.toggleBackorderMessage(false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateShippingInfo();
      this.updateLabel();
      this.setAttribute("data-variant-id", this.currentVariant.id);
    }

    if (!this.currentVariant) {
      //comment this as this.currentVariant is required for the function to execute
      // this.toggleAddButton(true, "", true);
      this.toogleOOSMessage(true, true);
      this.toggleBackorderMessage(false);
      //comment this as this.currentVariant is required for the function to execute
      // this.setUnavailable();
    } else {
      // console.log("Before updatemedia called");
      this.updateMedia();
      if(document.querySelector('bundled-product')){
        document.getElementById("isAlreadyTriggered").value="false";
        this.changeBundleImage();
      }
      if (document.body.classList.contains("product-template")) {
        this.updateURL();
      }
      if( !this.isProductHasBundle ) {
        this.updateVariantInput();
      }
      this.updateVariantInputShopPay();

      this.updateSubscriptionBox();
      this.renderProductInfo();
      this.updateShareUrl();
    }
    this.updateCarousalArrow();

    //buy from target processing
    this.buyFromTarget(e);
  }

  bundlePriceChange(){
    const bundleEle=document.querySelector('bundled-product');
    let cardFirst = 1;
    let cardSecond = 2;
    let cardThird = 3;
    if(bundleEle){
      const productVariants = document.querySelectorAll(
        "#total-variant__js li"
      );
      productVariants.forEach((variant) => {
        const variantTitle = variant.dataset.vtitle;

        if (variantTitle.includes(this.currentVariant.option1)) {
          let pdpCard = document.querySelectorAll('.pdp-bundle__bundle-card');
          let price = "$" + variant.dataset.vprice.replace(/\.00$/, "");
          let compareAtPrice = "$" + variant.dataset.vcompareprice.replace(/\.00$/, "");

          for (let index = 0; index < pdpCard.length; index++) {
            let card = pdpCard[index];
            let cardPrice = card.querySelector(`[data-price-type="price-${index + 1}"]`);
            let cardCompare = card.querySelector(`[data-price-type="compare-${index + 1}"]`);

            if (cardFirst === index + 1) {
              cardFirst = 0;
            } else if (cardSecond === index + 1) {
              cardSecond = 0;
            } else if (cardThird === index + 1) {
              cardThird = 0;
            } else {
              continue;
            }

            if (cardPrice) cardPrice.innerHTML = price;
            if (cardCompare) cardCompare.innerHTML = compareAtPrice + " value";
            break;
          }
        }
      });

    }
  }

  enableBadge() {
    const productSelectedVariant = document.querySelectorAll(
      "#total-variant__js li"
    );
    if (productSelectedVariant.length === 0) return;

    const showBadgeBlock = document.querySelectorAll(".show-badge");
    if (!showBadgeBlock) return;

    showBadgeBlock.forEach((badge) => {
      badge.classList.add("d-none");
    });

    if (!this.currentVariant || !this.currentVariant.id) return;

    productSelectedVariant.forEach((variant) => {
      const showBadge = variant.dataset.vbadge;
      const variantId = variant.dataset.vid;

      if (showBadge=="True" && this.currentVariant.id == variantId) {
        showBadgeBlock.forEach((badge) => {
          if(badge.classList.contains("d-none")){
            badge.classList.remove("d-none");
          }
        });
        return;
      }
    });
  }

  buyFromTarget(e){
    let targetUrl = '';

    const buyFromTarget = document.querySelector("a.btn--target");
    const soldOutText = document.querySelector(".js-sold-out-on-lalo");
    const productSelectedVariant = document.querySelectorAll(
      "#total-variant__js li"
    );

    productSelectedVariant.forEach((variant) => {
      const variantId = variant.dataset.vid;

      if (variantId == this.currentVariant.id) {
        targetUrl = variant.getAttribute('data-target-link');
      }
    });

    if (buyFromTarget) {
      if (targetUrl != "") {
        buyFromTarget.classList.remove("btn--target--disabled");
        buyFromTarget.classList.remove("d-none");
        buyFromTarget.setAttribute("href", targetUrl);
      } else {
        buyFromTarget.classList.add("btn--target--disabled");
        buyFromTarget.classList.add("d-none");
        buyFromTarget.setAttribute("href", "");
      }
    }


    if (soldOutText) {
      if (this.currentVariant.available === false) {
        soldOutText.classList.remove("d-none");
      } else {
        soldOutText.classList.add("d-none");
      }
    }
  }

  changeBundleImage() {
    if(this.currentVariant){
      let currentVariantTitle = this.currentVariant.title.split(" / ");
      const trimmedParts = currentVariantTitle.map(part => part.trim());
      let bundles = document.querySelectorAll(".js-bundle-select");
      bundles.forEach( (bundle) => {
        bundle.querySelectorAll("img").forEach((bundleImage) => {
          if(!bundleImage.classList.contains("d-none"))
            bundleImage.classList.add("d-none");
          let variantColor = bundleImage.getAttribute("data-variantcolor");
          let pillVariant = variantColor.split(" / ");
          let currentVariant = trimmedParts[0] + " / "+pillVariant[1];
          if(bundleImage.getAttribute("data-variantcolor") == currentVariant)
            bundleImage.classList.remove("d-none");
        });
      });

      let mainProduct = document.querySelector(".js-main-product bcard-variant");
      if(mainProduct){
        mainProduct.querySelectorAll("fieldset.color-variants input").forEach((colorInput) => {
          if(this.currentVariant.title.includes(currentVariantTitle[0])){
            if(colorInput.value == currentVariantTitle[0]){
              var mainLabel = colorInput.nextElementSibling;
              if(mainLabel)
                mainLabel.click();
            }
          }
        });
      }
    }
  }

  updateCarousalArrow() {
    const verticalSliderThumb = document.querySelector(
      ".vertical_slider_thumb"
    );
    if (verticalSliderThumb) {
      this.slider = verticalSliderThumb.querySelector('[id^="Slider-"]');
      this.sliderItems = verticalSliderThumb.querySelectorAll('[id^="Slide-"]');

      this.sliderItemsToShow = Array.from(this.sliderItems).filter(
        (element) => element.clientHeight > 0
      );
      if (this.sliderItemsToShow.length < 2) {
        verticalSliderThumb
          .querySelectorAll("button.slider-button")
          .forEach((element) => {
            element.classList.add("d-none");
          });
        return;
      }
      this.sliderItemOffsetY =
        this.sliderItemsToShow[1].offsetTop -
        this.sliderItemsToShow[0].offsetTop;
      this.slidesPerPageY = Math.floor(
        this.slider.clientHeight / this.sliderItemOffsetY
      );
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPageY + 1;

      verticalSliderThumb
        .querySelectorAll("button.slider-button")
        .forEach((element) => {
          if (this.totalPages > 0) {
            verticalSliderThumb
              .querySelector("button.slider-button--next")
              .classList.remove("d-none");
          } else {
            element.classList.add("d-none");
          }
        });
    }
  }

  updateShippingInfo() {
    var variantShippingInfos = document.querySelectorAll(".shipping-info");
    variantShippingInfos.forEach((info) => {
      info.classList.replace("d-block", "d-none");
      var infoVariantId = info.getAttribute("data-variant-id");
      if (infoVariantId == this.currentVariant.id) {
        info.classList.remove("d-none");
        info.classList.add("d-block");
      }
    });
  }

  updateLabel() {
    // console.log(this.options)
  }

  updateOptions() {
    this.optionsSelect = this.optionsRadio = [];
    if (this.querySelector("select")) {
      this.optionsSelect = Array.from(
        this.querySelectorAll("select"),
        (select) => select.value
      );
    }

    if (this.querySelector("fieldset")) {
      const fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.optionsRadio = fieldsets.map((fieldset) => {
        const checkedData = Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
        fieldset.querySelector("legend .selected").innerHTML = checkedData;
        return checkedData;
      });
    }
    if (this.firstElementChild.classList.contains("variation-dropdown")) {
      this.options = this.optionsSelect.concat(this.optionsRadio);
    } else {
      this.options = this.optionsRadio.concat(this.optionsSelect);
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  bundleKitMessages(isInit = false) {
    let pillsEl = document.querySelectorAll(".pills_js input");

    pillsEl.forEach((element) => {
      const totalVariants = document.querySelectorAll(
        "#total-variant__js ul li"
      );
      totalVariants.forEach((item) => {
        if (item.dataset.vtitle.includes(element.value)) {
          let variantMessage = item.dataset.vmessage;
          if (variantMessage == "none") variantMessage = false;
          if (variantMessage) {
            element.parentNode.querySelector(
              '[data-kid="kit-message__js"]'
            ).innerHTML =
              '<span class=" position-relative tag tag--variant caption-sm bg-basil text-white py-1 px-2 fw-medium text-capitalize">' +
              variantMessage +
              "</span>";
          }
        }
      });
    });

    let customDropDown = document.querySelectorAll(
      "select[data-bundledropdown]"
    );

    if (customDropDown.length > 0) {
      let bDropDown = document.querySelectorAll(
        ".variant-starts .custom-select"
      );
      let dropdownElSelect = document.querySelector(
        "select[data-bundledropdown]"
      );

      bDropDown.forEach((element) => {
        let eachContent = element.dataset.each;
        if (eachContent == "") eachContent = "each";
        let dropDownList = element.querySelectorAll(".dropdown-menu li");
        dropDownList.forEach((li, i) => {
          li.outerHTML = li.outerHTML;
        });
        let dropDownLists = element.querySelectorAll(".dropdown-menu li");
        dropDownLists.forEach((li, i) => {
          const totalVariants = document.querySelectorAll(
            "#total-variant__js ul li"
          );
          const elementInnerHtml = li.dataset.value;
          const bundleNumber = li.dataset.value.match(/\d+/)[0];
          totalVariants.forEach((item) => {
            if (item.dataset.vtitle.includes(li.dataset.value)) {
              let variantMessage = item.dataset.vmessage;
              let variantPrice = item.dataset.vprice;
              let variantEachPrice = (variantPrice / bundleNumber).toFixed(2);

              if (variantMessage || bundleNumber > 1) {
                // if (variantMessage == "none") variantMessage = "";
                li.innerHTML = `<div class="custom-select__option"><span class="bundle-data">${elementInnerHtml}</span> ($${variantEachPrice} ${eachContent}) <span class="variant-message">${variantMessage}</span></div>`;
              }
            }
          });

          li.classList.remove("new-style");
          let dropDownBtn;
          li.addEventListener("click", (e) => {
            element.querySelector("button").innerHTML =
              e.target.closest("li").innerHTML;
            dropdownElSelect.options[i].selected = true;
            this.fireEvent(dropdownElSelect, "change");
            dropDownBtn = element.querySelector("button");
            dropDownBtn.setAttribute("data-li", li.dataset.value);
          });
          dropDownBtn = element.querySelector("button");
          setTimeout(() => {
            if (dropDownBtn.dataset.li == li.dataset.value) {
              li.classList.add("new-style");
            }
          }, 500);
          // element.querySelector('.dropdown-menu li[selected="selected"]').classList.add('d-none');
        });
        if (isInit) {
          let dropDownBtn = element.querySelector("button");
          dropDownBtn.innerHTML = element.querySelector(
            '.dropdown-menu li[selected="selected"]'
          ).innerHTML;
          // element
          //   .querySelector('.dropdown-menu li[selected="selected"]')
          //   .classList.add("d-none");
        }
      });
    }
  }

  fireEvent(element, event) {
    if (document.createEventObject) {
      // dispatch for IE
      var evt = document.createEventObject();
      return element.fireEvent("on" + event, evt);
    } else {
      // dispatch for firefox + others
      var evt = document.createEvent("HTMLEvents");
      evt.initEvent(event, true, true); // event type,bubbling,cancelable
      return !element.dispatchEvent(evt);
    }
  }

  hideVariant(variantObj = null, hideFirst = false) {
    const totalVariant = document.querySelectorAll("#total-variant__js li");
    const noCrossFirstOption = document.querySelector('input[name="show_first_option"]') ? document.querySelector('input[name="show_first_option"]').value : 'false';
    let availableCombinations = new Set();
    let validFirstOptions = new Set();
    let validSecondOptions = new Set();
    let validThirdOptions = new Set();

    // Build sets of available combinations and valid options
    totalVariant.forEach((item) => {
      let title = item.dataset.vtitle;
      let hide = item.dataset.vhide === "true";
      if (!hide) {
        availableCombinations.add(title);
        const [first, second, third] = title.split("/").map((s) => s.trim());

        // Collect valid first options when second and/or third options are selected
        if (variantObj && variantObj.option2) {
          if (
            second === variantObj.option2.trim() &&
            (!variantObj.option3 || third === variantObj.option3.trim())
          ) {
            validFirstOptions.add(first);
          }
        }

        // Collect valid second options when first and/or third options are selected
        if (variantObj && variantObj.option1) {
          if (
            first === variantObj.option1.trim() &&
            (!variantObj.option3 || third === variantObj.option3.trim())
          ) {
            validSecondOptions.add(second);
          }
        }

        // Collect valid third options when first and/or second options are selected
        if (variantObj && (variantObj.option1 || variantObj.option2)) {
          if (
            (!variantObj.option1 || first === variantObj.option1.trim()) &&
            (!variantObj.option2 || second === variantObj.option2.trim())
          ) {
            validThirdOptions.add(third);
          }
        }
      }
    });

    if(!hideFirst) {
      // Handle first-level options visibility
      if (variantObj && (variantObj.option2 || variantObj.option3)) {
        // Handle color swatches
        const colorSwatches = document.querySelectorAll(
          'variant-starts .color-swatch-variant[data-swatch-index="1"] label'
        );
        colorSwatches.forEach((swatch) => {
          const color = swatch.querySelector("span")?.textContent?.trim();
          if (color) {
            if (validFirstOptions.has(color)) {
              swatch.classList.remove("d-none");
              swatch.parentElement?.classList.remove("d-none");
            } else {
              swatch.classList.add("d-none");
              swatch.parentElement?.classList.add("d-none");
            }
          }
        });

        // Handle color dropdown
        const colorDropdown = document.querySelectorAll(
          'variant-starts [data-dropdown-index="1"] select option'
        );
        colorDropdown.forEach((option) => {
          const optionValue = option.value.trim();
          if (validFirstOptions.has(optionValue)) {
            option.classList.remove("d-none");
          } else {
            option.classList.add("d-none");
          }
        });

        // Handle kit pills
        const kitPillsFirst = document.querySelectorAll(
          "variant-starts .pills_js[data-kit-index='1'] .p-form-data"
        );
        kitPillsFirst.forEach((pill) => {
          const value = pill.querySelector("input")?.value?.trim();
          if (value) {
            if (validFirstOptions.has(value)) {
              pill.classList.remove("d-none");
            } else {
              if(noCrossFirstOption == false){
                pill.classList.add("d-none");
              }
            }
          }
        });
      }
    }


    // Handle second-level options visibility
    if (variantObj && (variantObj.option1 || variantObj.option3)) {
      // Handle kit pills
      const kitPills = document.querySelectorAll(
        'variant-starts .pills_js[data-kit-index="2"] .p-form-data'
      );
      kitPills.forEach((pill) => {
        const value = pill.querySelector("input")?.value?.trim();
        if (value) {
          if (validSecondOptions.has(value)) {
            pill.classList.remove("d-none");
          } else {
            pill.classList.add("d-none");
          }
        }
      });

      // Handle dropdown
      const kitDropdown = document.querySelectorAll(
        'variant-starts [data-dropdown-index="2"] select option'
      );
      kitDropdown.forEach((option) => {
        const optionValue = option.value.trim();
        if (validSecondOptions.has(optionValue)) {
          option.classList.remove("d-none");
        } else {
          option.classList.add("d-none");
        }
      });

      // Handle swatches
      const kitSwatches = document.querySelectorAll(
        'variant-starts .color-swatch-variant[data-swatch-index="2"] label'
      );

      kitSwatches.forEach((swatch) => {
        const swatchLabel = swatch.querySelector("span")?.textContent?.trim();
        if (swatchLabel) {
          if (validSecondOptions.has(swatchLabel)) {
            swatch.classList.remove("d-none");
            swatch.parentElement?.classList.remove("d-none");
          } else {
            swatch.classList.add("d-none");
            swatch.parentElement?.classList.add("d-none");
          }
        }
      });
    }

    // Handle third-level options visibility
    if (variantObj && (variantObj.option1 || variantObj.option2)) {
      // Handle kit pills
      const kitPills = document.querySelectorAll(
        'variant-starts .pills_js[data-kit-index="3"] .p-form-data'
      );
      kitPills.forEach((pill) => {
        const value = pill.querySelector("input")?.value?.trim();
        if (value) {
          if (validThirdOptions.has(value)) {
            pill.classList.remove("d-none");
          } else {
            pill.classList.add("d-none");
          }
        }
      });

      // Handle dropdown
      const kitDropdown = document.querySelectorAll(
        'variant-starts [data-dropdown-index="3"] select option'
      );
      kitDropdown.forEach((option) => {
        const optionValue = option.value.trim();
        if (validThirdOptions.has(optionValue)) {
          option.classList.remove("d-none");
        } else {
          option.classList.add("d-none");
        }
      });

      // Handle swatches
      const kitSwatches = document.querySelectorAll(
        'variant-starts .color-swatch-variant[data-swatch-index="3"] label'
      );
      kitSwatches.forEach((swatch) => {
        const swatchLabel = swatch.querySelector("span")?.textContent?.trim();
        if (swatchLabel) {
          if (validThirdOptions.has(swatchLabel)) {
            swatch.classList.remove("d-none");
            swatch.parentElement?.classList.remove("d-none");
          } else {
            swatch.classList.add("d-none");
            swatch.parentElement?.classList.add("d-none");
          }
        }
      });
    }

    // Reset visibility when no options are selected
    if ( !variantObj || (!variantObj.option1 && !variantObj.option2 && !variantObj.option3)) {
      const allOptions = document.querySelectorAll(`
          variant-starts .color-swatch-variant[data-swatch-index="1"] label,
          variant-starts [data-dropdown-index="1"] select option,
          variant-starts .pills_js[data-kit-index="1"] .p-form-data,
          variant-starts [data-dropdown-index="2"] select option,
          variant-starts .pills_js[data-kit-index="2"] .p-form-data,
          variant-starts .color-swatch-variant[data-swatch-index="2"] label,
          variant-starts [data-dropdown-index="3"] select option,
          variant-starts .pills_js[data-kit-index="3"] .p-form-data,
          variant-starts .color-swatch-variant[data-swatch-index="3"] label
      `);

      totalVariant.forEach((item) => {
        const hide = item.dataset.vhide === "true";
        if (!hide) {
          const [first, second, third] = item.dataset.vtitle
            .split("/")
            .map((s) => s.trim());
          allOptions.forEach((option) => {
            const optionValue =
              option.querySelector("input")?.value ||
              option.value ||
              option.querySelector("span")?.textContent;
            if (
              optionValue?.trim() === first ||
              optionValue?.trim() === second ||
              optionValue?.trim() === third
            ) {
              option.classList.remove("d-none");
              option.parentElement?.classList.remove("d-none");
            }
          });
        }
      });
    }

    // Handle sold-out state with flexible variant types
    totalVariant.forEach((item) => {
      const variantStock = item.dataset.vstock === "true";
      const [first, second, third] = item.dataset.vtitle
        .split("/")
        .map((s) => s.trim());

      // Helper function to handle sold-out state for any variant type
      const handleVariantSoldOut = (level, value) => {
        // Handle all possible UI elements for the given level
        const variantSelectors = [
          `.color-swatch-variant[data-swatch-index="${level}"] label`,
          `.pills_js[data-kit-index="${level}"] .p-form-data label`,
          `[data-dropdown-index="${level}"] select option`,
        ];

        variantSelectors.forEach((selector) => {
          const elements = document.querySelectorAll(
            `variant-starts ${selector}`
          );

          elements.forEach((element) => {
            // Get element value based on its type
            const elementValue =
              element.textContent?.trim() ||
              element.querySelector("span")?.textContent?.trim() ||
              element.value?.trim();

            if (elementValue === value) {
              if (variantStock) {

                if(noCrossFirstOption == "true" && level == 1){
                  element.classList.remove("sold-out");
                  // Add disabled attribute only for dropdown options
                  if (element.tagName.toLowerCase() === "option") {
                    element.setAttribute("disabled", "disabled");
                  }
                }
                else{
                  element.classList.add("sold-out");
                  if (element.tagName.toLowerCase() === "option") {
                    //element.setAttribute("disabled", "disabled");
                    element.removeAttribute("disabled");
                  }
                }
              } else {
                element.classList.remove("sold-out");
                if (element.tagName.toLowerCase() === "option") {
                  element.removeAttribute("disabled");
                }
              }
            }
          });
        });
      };

      // Handle first variant when second and/or third are selected
      if (
        variantObj?.option2 &&
        second === variantObj.option2.trim() &&
        (!variantObj?.option3 || third === variantObj.option3.trim())
      ) {
        handleVariantSoldOut(1, first);
      }

      // Handle second variant when first and/or third are selected
      if (
        variantObj?.option1 &&
        first === variantObj.option1.trim() &&
        (!variantObj?.option3 || third === variantObj.option3.trim())
      ) {
        handleVariantSoldOut(2, second);
      }

      // Handle third variant when first and second are selected
      if (
        variantObj?.option1 &&
        first === variantObj.option1.trim() &&
        variantObj?.option2 &&
        second === variantObj.option2.trim()
      ) {
        handleVariantSoldOut(3, third);
      }
    });
  }

  //Force Set to First variant active on second option when first option is selected
  forcedSetActiveInSecondOption(e) {

    let variantStartElm = e.target.closest('variant-starts');
    let firstActiveJs = variantStartElm?.querySelector('.first_active__js');
    const noCrossFirstOption = document.querySelector('input[name="show_first_option"]') ? document.querySelector('input[name="show_first_option"]').value : 'false';

    //if there is required to forced to change variant of this option active
    if(firstActiveJs) {
      let closestFieldset = e.target.closest('fieldset');
      if(closestFieldset && closestFieldset.classList.contains('pills_js')) {
        let allVariant = firstActiveJs.querySelectorAll('.color-swatch-main-product');
        let activeVariant = firstActiveJs.querySelectorAll('.color-swatch-main-product:not(.d-none)');
        if(!this.currentVariant) {

          for(let i = 0; i < allVariant.length; i++) {
            if(!this.currentVariant) {
              if(noCrossFirstOption == "true"){
                let particularVariant = firstActiveJs.querySelectorAll('.order-1');
                particularVariant[0].querySelector('label').click();
              }
              else
              allVariant[i].querySelector('label').click();
            }
          }
        } else {
          // let hasChecked = false;
          // activeVariant.forEach( (act) => {
          //   if(!act.querySelector("input:checked"))
          //     hasChecked = true;
          // });
          // if(hasChecked === false)
          if(noCrossFirstOption == "true"){
            let particularVariant = firstActiveJs.querySelectorAll('.order-1');
            particularVariant[0].querySelector('label').click();
          }
          else
            activeVariant[0].querySelector('label').click();
        }
      }
    }
  }

  checkKitMessage(variantObj = null, e = null) {
    if (e == null) {
      let pillsEl = document.querySelectorAll(".pills_js");
      pillsEl.forEach((element) => {
        e = element.querySelector("input[checked]");
      });
    }
    const totalVariant = document.querySelector("#total-variant__js");
    if (totalVariant && variantObj != null && e != null) {
      let variantMessage = totalVariant.querySelector(
        `[data-vid="${variantObj.id}"]`
      );
      let variantTitle = variantMessage ? variantMessage.dataset.vtitle : false;
      variantMessage = variantMessage ? variantMessage.dataset.vmessage : false;
      if (variantMessage && variantTitle) {
        variantTitle = variantTitle.split(" / ");
        let parentNode = e;
        if (e.target != undefined) {
          parentNode = e.target;
        }
        if (
          parentNode.parentNode.querySelector('[data-kid="kit-message__js"]') !=
          null
        ) {
          parentNode.parentNode.querySelector(
            '[data-kid="kit-message__js"]'
          ).innerHTML =
            '<span class=" position-relative tag tag--variant caption-sm bg-basil text-white py-1 px-2 fw-medium text-capitalize">' +
            variantMessage +
            "</span>";
        }
      } else {
        let kids = document.querySelectorAll(`[data-kid="kit-message__js"]`);
        kids.forEach((element) => {
          element.innerHTML = "";
        });
      }
    }
  }

  handleize(name) {
    return name
      .toLowerCase()
      .replace(/[^\w\u00C0-\u024f]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  customizedVariantSwitch(pdpPwwBlock, circleVariantName, fallbackVariantName) {
    if (circleVariantName == undefined || circleVariantName == null) return;
    let colorVariantBgClassName = "bg-".concat(circleVariantName);
    let isTriggered = null;
    let isCustomized = false;

    const bundledProduct = document.querySelector("bundled-product");
    if(bundledProduct){
      isCustomized = bundledProduct && bundledProduct.classList.contains("is-customized");
      isTriggered = document.getElementById("isAlreadyTriggered").value;
    }
    let eachBlock = pdpPwwBlock.querySelectorAll(".pdpfwp_section__js");
    eachBlock.forEach((block) => {
      block.classList.remove("is-oos-product");
      block.querySelector(".oos-info__msg").classList.add("d-none");

      if (block.querySelectorAll(".swatch a").length == 1) return;

          // Check fallback first if metafield exists
      if (fallbackVariantName && fallbackVariantName.trim() !== "") {
        var fallbackVariantNameArr = fallbackVariantName.split(",");
        let fallbackFound = false;

        fallbackVariantNameArr.forEach((variantName) => {
          let variantClassname = "bg-".concat(variantName.replace(" ", ""));

          if (block.querySelector(`a.${variantClassname}`)) {
            block.querySelector(`a.${variantClassname}`).click();
            fallbackFound = true;
          } else if (block.querySelectorAll(`label.${variantClassname}`).length > 0) {
            block.querySelectorAll(`label.${variantClassname}`).forEach((label) => {
              label.click();
            });
            fallbackFound = true;
          }
        });

      if (fallbackFound) {
        if (document.querySelectorAll(".js-bundle-select").length > 0) {
          var selected = document.querySelectorAll(".js-bundle-select");
          selected.forEach((sel) => {
            if (sel.classList.contains("active")) {
              sel.click();
            }
          });
        }

        // Handle bundle variants if needed
        if (block.querySelector("bcard-variant .bundle-variants")) {
          block
            .querySelector("bcard-variant .bundle-variants")
            ?.querySelectorAll(
              `label.${fallbackVariantNameArr[0].replace(" ", "")}`
            )[0]
            ?.click();
        }

        // Handle bundle name updates
        let currentBundleName = this.currentVariant.title.split(" / ");
        if (
          document.querySelector(
            "[data-bundle-name='" + currentBundleName[1] + "']"
          )
        ) {
          if (isCustomized === false && isTriggered == "false") {
            document
              .querySelector("[data-bundle-name='" + currentBundleName[1] + "']")
              .click();
          }
          document
            .querySelector("[data-bundle-name='" + currentBundleName[1] + "']")
            .setAttribute("data-bundle-variant-id", this.currentVariant.id);
        } else if (document.querySelector(".js-bundle-select").length > 0) {
          var selected = document.querySelectorAll(".js-bundle-select");
          selected.forEach((sel) => {
            if (sel.classList.contains("active")) {
              sel.click();
            }
          });
        }

        return;
      }
    }

    if (block.querySelector(`a.${colorVariantBgClassName}`) != null) {
        block.querySelector(`a.${colorVariantBgClassName}`).click();
        if (document.querySelectorAll(".js-bundle-select").length > 0) {
          var selected = document.querySelectorAll(".js-bundle-select");
          selected.forEach((sel) => {
            if (sel.classList.contains("active")) {
                sel.click();
            }
          });
        }
      } else if (block.querySelectorAll(`label.${colorVariantBgClassName}`).length > 0) {
        block
          .querySelectorAll(`label.${colorVariantBgClassName}`)
          .forEach((label) => {
            label.click();
          });

          if(block.querySelector("bcard-variant .bundle-variants")){
            block
              .querySelector("bcard-variant .bundle-variants")
              ?.querySelectorAll(`label.${colorVariantBgClassName}`)[0]
              ?.click();
          }

        let currentBundleName = this.currentVariant.title.split(" / ");
        if (
          document.querySelector(
            "[data-bundle-name='" + currentBundleName[1] + "']"
          )
        ) {

          if (isCustomized === false && isTriggered == "false") {
            document
              .querySelector("[data-bundle-name='" + currentBundleName[1] + "']")
              .click();
          }

          document.querySelector("[data-bundle-name='" + currentBundleName[1] + "']").setAttribute("data-bundle-variant-id", this.currentVariant.id);
        } else if (document.querySelector(".js-bundle-select").length > 0) {
          var selected = document.querySelectorAll(".js-bundle-select");
          selected.forEach((sel) => {
            if (sel.classList.contains("active")) {
                sel.click();
              }
            });
          }
      }
      else {
        if (block.querySelector("bcard-variant .bundle-variants")) {
          block
            .querySelector("bcard-variant .bundle-variants")
            ?.querySelectorAll('label')[0]
            ?.click();
        }
        if (fallbackVariantName != "") {
          var fallbackVariantNameArr = fallbackVariantName.split(",");
          fallbackVariantNameArr.map((variantName) => {
            let variantClassname = "bg-".concat(variantName.replace(" ", ""));

            if (block.querySelector(`label.${variantClassname}`)) {
              block
                .querySelectorAll(`label.${variantClassname}`)
                .forEach((label) => {
                  label.click();
                });
              // block.querySelector(`label.${variantClassname}`).click();
            }
          });
          if (block.querySelector("bcard-variant .bundle-variants")) {
            block
              .querySelector("bcard-variant .bundle-variants")
              ?.querySelectorAll('label')[0]
              ?.click();
          }
        } else {
          if (block.getAttribute("data-isbundle") === false) {
            block.classList.add("is-oos-product");
            block.querySelector(".oos-info__msg").classList.remove("d-none");
          }
        }
      }
    });
  }

  updateMedia() {
    //changes
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    //for flickty slider
    if (document.querySelector(".product__image-slider")) {
      var flktyDom = document.querySelector(".product__image-slider").innerHTML;
      this.currentVariantOptionLowercase = this.currentVariant.options.map(
        (list) => {
          return this.handleize(list.trim().toLowerCase());
        }
      );
      this.currentVariantTitle = this.currentVariantOptionLowercase.join("|");
      if (
        document.querySelector(
          ".pdp_pww_block, .pdp_fwp_block, .pdp_bundle_block"
        )
      ) {
        //console.log("Before loop: "+this.currentVariantTitle);
        document
          .querySelectorAll(".pdp_pww_block, .pdp_fwp_block, .pdp_bundle_block")
          .forEach((pdpPwwBlock) => {
            //console.log("XMXM: "+pdpPwwBlock.getAttribute("class"));

            if (pdpPwwBlock.getAttribute("data-sync") == "true") {
              // console.log("data sync true");

              // console.log("Current variant title: "+this.currentVariant.title);
              let getVariantInfo = document.querySelector(
                `#total-variant__js ul [data-vid="${this.currentVariant.id}"]`
              );
              let getVariantName = document.querySelector(
                `#total-variant__js ul [data-vtitle="${this.currentVariant.id}"]`
              );
              let fallbackVariantName = getVariantInfo.getAttribute(
                "data-fallbackvariant"
              );
              //console.log("Ayaz is in 24 Dec :"+this.currentVariantOptionLowercase);
              this.customizedVariantSwitch(
                pdpPwwBlock,
                this.currentVariantOptionLowercase[0],
                fallbackVariantName
              );
            }
          });
      }

      var elem = document.querySelector(".carousel.product__image-slider");
      this.matchedData = Array(...window.productFlktyDom).filter((item) => {
        if (
          item.getAttribute("data-alt").includes(this.currentVariantTitle) &&
          !item
            .getAttribute("data-alt")
            .includes(this.currentVariantTitle + "-") &&
          !item
            .getAttribute("data-alt")
            .includes("-" + this.currentVariantTitle)
        ) {
          return item
            .getAttribute("data-alt")
            .includes(this.currentVariantTitle);
        }
      });
      var elemNew = document.querySelector(".carousel.product__image-slider");
      flkty.destroy();
      this.matchedDataHtml = this.matchedData.map((el) => el.outerHTML);
      elemNew.innerHTML = this.matchedDataHtml.join("");
      if (!elemNew.classList.contains("flickity-enabled")) {
        flkty = new Flickity(elemNew, window.flktyOptions);

        flkty.on('change', function(index) {
          var currentSlide = flkty.selectedElement;
          const zoomEl = document.querySelector('.product-zoom-icon');
          if(zoomEl){
            if(currentSlide.getAttribute('data-media') == 'video'){
              zoomEl.classList.add('d-none');
            }
            else{
              zoomEl.classList.remove('d-none');
            }
          }
        });

        flkty.on('staticClick', async (event, pointer, cellElement, cellIndex) => {
          const img = event.target.closest('.image-magnify-hover');
          if (!img) return;
          const overlayEl = magnify(img, 1.5, { mount: '.lalo-product-zoom' });
          zoomState.currentOverlay = overlayEl;
          await overlayEl._readyPromise;
          const pointerType = pointer?.pointerType || (event?.pointerType) || (event?.type?.startsWith('touch') ? 'touch' : 'mouse');

          moveWithHover(overlayEl, img, event, 1.5, pointerType === 'touch' ? 'touch' : 'mouse');
        });
      }
    } else {
      this.currentVariantOptionLowercase = this.currentVariant.options.map(
        (list) => {
          return this.handleize(list.trim().toLowerCase());
        }
      );
      this.currentVariantTitle = this.currentVariantOptionLowercase.join("|");

      if (
        document.querySelector(
          ".pdp_pww_block, .pdp_fwp_block, .pdp_bundle_block"
        )
      ) {
        document
          .querySelectorAll(".pdp_pww_block, .pdp_fwp_block, .pdp_bundle_block")
          .forEach((pdpPwwBlock) => {
            if (pdpPwwBlock.getAttribute("data-sync") == "true") {
              let getVariantInfo = document.querySelector(
                `#total-variant__js ul [data-vid="${this.currentVariant.id}"]`
              );
              let fallbackVariantName = getVariantInfo.getAttribute(
                "data-fallbackvariant"
              );
              this.customizedVariantSwitch(
                pdpPwwBlock,
                this.currentVariantOptionLowercase[0],
                fallbackVariantName
              );
            }
          });
      }

      const mediaGallery = document.getElementById(
        `MediaGallery-${this.dataset.section}`
      );

      this.matchedData = Array(...this.thumbnailData).map((thumbs) => {
        var altImages = thumbs.querySelector("img").getAttribute("data-alt");
        if (thumbs.classList.contains("js-newGallery")) {
          var altImages = thumbs.querySelector("img").getAttribute("data-alt");
        } else if (altImages == null) {
          var altImages = thumbs
            .querySelector("img")
            .getAttribute("alt")
            .replace("lalo2.0_", "");
        }
        var altImages = altImages.replace("lalo2.0_", "");

        const imagesAlts = altImages.split(",");
        thumbs.classList.add("d-none");
        if (thumbs.classList.contains("is-active")) {
          thumbs.classList.remove("d-none");
        }
        if (imagesAlts.includes(this.currentVariantTitle)) {
          // thumbs.style.display = "block";
          thumbs.classList.remove("d-none");
          // return thumbs;
        }
      });
      this.matchedMediaData = Array(...this.mediaData).map((medias) => {
        if (medias.querySelector("img") != null) {
          var altImages = medias.querySelector("img").getAttribute("data-alt");
          if (medias.classList.contains("js-newGallery")) {
            var altImages = medias
              .querySelector("img")
              .getAttribute("data-alt");
          } else if (altImages == null) {
            var altImages = medias
              .querySelector("img")
              .getAttribute("alt")
              .replace("lalo2.0_", "");
          }
          var altImages = altImages.replace("lalo2.0_", "");

          const imagesAlts = altImages.split(",");
          medias.classList.add("d-none");
          if (
            imagesAlts.includes(this.currentVariantOptionLowercase.join("|"))
          ) {
            medias.classList.remove("d-none");
          }
        }
        // console.log(altImages);
      });

      this.activeThumbs = Array(...this.thumbnailData).filter((thumbs) => {
        return !thumbs.classList.contains("d-none");
      });
      if (this.activeThumbs[0]) {
        mediaGallery.setActiveMedia(
          `${this.activeThumbs[0].dataset.target}`,
          true
        );
      }

      this.matchedData = this.matchedData.filter((x) => x !== undefined);
      this.matchedDataHtml = this.matchedData.map((el) => el.outerHTML);

      if(document.querySelector(".thumbnail-list")){
        const sliderId = document
          .querySelector(".thumbnail-list")
          .getAttribute("id");
        document
          .getElementById(sliderId)
          .scrollTo({ top: 0, behavior: "smooth" });
      }
      if(document.querySelector(".product__media-list")){
        const productMediaListId = document
          .querySelector(".product__media-list")
          .getAttribute("id");

        document
          .getElementById(productMediaListId)
          .scrollTo({ left: 0, behavior: "smooth" });
      }
      // this.mediaData.parentNode.scrollTo({ top: 0, behavior: "smooth" });

      const modalContent = document.querySelector(
        `#ProductModal-${this.dataset.section} .product-media-modal__content`
      );
      const newMediaModal = modalContent.querySelector(
        `[data-media-id="${this.currentVariant.featured_media.id}"]`
      );
      // modalContent.prepend(newMediaModal);
    }
    if (document.querySelector(".sticky-atc, .subscription-sticky-atc"))
      this.updateATC();

    //this will not get trigerred if called from bundle
    // document.getElementById("isAlreadyTriggered").value=false;
    // if (isAlreadyTriggered === true) {
    //   isAlreadyTriggered = false;
    //   return;
    // }
  }

  updateATC() {
    let stickyBottomTotalPrice = document.getElementById(
      "stickyBottomTotalPrice"
    );
    let pdpPwwtotalPrice = document.querySelector(".pdpPww-total-price__js");
    if (stickyBottomTotalPrice != null && pdpPwwtotalPrice != null) {
      let pdpTotalPrice = pdpPwwtotalPrice.innerHTML;
      stickyBottomTotalPrice.innerHTML = pdpTotalPrice;
    }
    /**For color section*/
    // let productSelectedColorVariant = document.querySelector('variant-starts .color-swatch-variant .selected').innerHTML;
    // document.querySelector('.sticky-atc .color-swatch-variant').innerHTML = productSelectedColorVariant;

    let productSelectedColorVariantLabel = document.querySelector(
      "variant-starts .color-swatch-variant .color-swatch-main-product input:checked ~ label"
    );
    let colorSwatchLabel = document.querySelector(
      ".sticky-atc .color-swatch-variant label"
    );
    if (productSelectedColorVariantLabel) {
      let clonedVariantLabel = productSelectedColorVariantLabel.cloneNode(true);
      clonedVariantLabel.removeAttribute("for");
      clonedVariantLabel.setAttribute("aria-hidden", "true");
      colorSwatchLabel.replaceWith(clonedVariantLabel);
    } else {
      colorSwatchLabel.classList.add("d-none");
    }

    let colorSwatch = document.querySelector(
      ".sticky-atc .color-swatch-variant > span"
    );
    let productSelectedColorVariant = document.querySelector(
      "variant-starts .color-swatch-variant .selected"
    );
    let productSelectedDropdownVariantLabel = document.querySelector(
      "variant-starts .js-mainProductDropdownVariant select"
    );

    if (productSelectedColorVariant) {
      colorSwatch.innerHTML = productSelectedColorVariant.innerHTML;
    } else if (productSelectedDropdownVariantLabel) {
      colorSwatch.innerHTML = productSelectedDropdownVariantLabel.value;
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantInputShopPay() {
    const productForms = document.querySelectorAll(
      `#product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateSubscriptionBox() {
    var subscriptionPlanBox = document.querySelector(
      "#js-subscriptionBoxPlanSelectorBlockNormal"
    );

    if (subscriptionPlanBox) {
      subscriptionPlanBox.setAttribute("data-selling-plan-id-subscription", "");

      var subscriptionBox = subscriptionPlanBox.querySelectorAll(
        "#js-subscriptionBoxPlanSelectorBlockNormal .subscription-box-wrapper"
      );

      if (subscriptionBox.length > 0) {
        var subscriptionInput = document.querySelector(
          "input.main-form-selling-plan-input"
        );

        var changeObserver = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (mutation.type === "attributes") {
              var sellingPlanId = subscriptionPlanBox.getAttribute(
                "data-selling-plan-id-subscription"
              );
              subscriptionInput.value = sellingPlanId;
            }
          });
        });

        changeObserver.observe(subscriptionPlanBox, {
          attributes: true,
        });

        subscriptionBox.forEach((box) => {
          box.classList.replace("d-none", "d-flex");
          box.querySelector("input[data-type=onetime]").checked = false;
          box
            .querySelector("input[data-type=onetime]")
            .removeAttribute("checked");
          box
            .querySelector("input[data-type=onetime]")
            .setAttribute("data-selected-block", false);
          var selectedVariantId = box.getAttribute(
            "data-subscription-variant-id"
          );

          if (selectedVariantId == this.currentVariant.id) {
            box.classList.replace("d-none", "d-flex");
            box.querySelector("input[data-type=onetime]").checked = true;
            box
              .querySelector("input[data-type=onetime]")
              .setAttribute("checked", "checked");
            box
              .querySelector("input[data-type=onetime]")
              .setAttribute("data-selected-block", true);
            box
              .querySelector("input[data-type=onetime]")
              .dispatchEvent(new Event("change", { bubbles: true }));
          } else {
            box.classList.replace("d-flex", "d-none");
          }
        });
      }

      if (this.currentVariant && this.currentVariant.available == false) {
        document.querySelector(
          ".subscription-sticky-atc .atc-bundle_info .text-lalo-ink"
        ).innerHTML = this.currentVariant.title;
      }
    }
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  resetCustomizedProduct() {
    if (document.querySelector(".pdp_pww_block, .pdp_fwp_block")) {
      document
        .querySelectorAll(".pdp_pww_block, .pdp_fwp_block")
        .forEach((pdpPwwBlock) => {
          if (pdpPwwBlock.getAttribute("data-sync") == "true") {
          }
          pdpPwwBlock
            .querySelectorAll('.checked[data-id="product-pdp_pww"]')
            .forEach((checkBox) => {
              let clickEvent = new Event("click");
              checkBox.dispatchEvent(clickEvent);
            });
        });
    }
  }

  renderProductInfo() {
    this.resetCustomizedProduct();
    if (
      document.querySelector(".product-template") &&
      document.querySelector("quantity-input")
    ) {
      document.querySelector("quantity-input").classList.add("pe-none");
    }
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.psection}`;
        const mobileId = `price-${this.dataset.psection}-mobile`;
        const html = new DOMParser().parseFromString(responseText, "text/html");

        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        if (source) {
          let salePrice = source.querySelector(
            ".price__sale .price-item--sale"
          );
          let regularPrice = source.querySelector(
            ".price__regular .price-item--regular"
          );
          if (salePrice) {
            salePrice = salePrice.innerHTML.trim();
          } else {
            salePrice = "";
          }
          if (regularPrice) {
            regularPrice = regularPrice.innerHTML.trim();
          } else {
            regularPrice = "";
          }
          // console.log("Remove comment below this line to show the bundle discounted price");
          let isCustomized = false;
          const bundledProduct = document.querySelector("bundled-product");

          if(bundledProduct){
            if(bundledProduct.classList.contains("is-customized") === true)
              isCustomized = true;
            else
              isCustomized = false;
          }
          // console.log("isCustomized: "+isCustomized);
          if(isCustomized === false){
            if (document.querySelector(".pdpPww-total-price__js")) {
              if (source && destination) {
                document
                  .querySelector(".pdpPww-total-price__js")
                  .querySelector(".renderPrice").innerHTML = source.innerHTML;
                this.yourTotalSectionUpdate(salePrice, regularPrice);
              }
            }
          }

          if (source && destination) {
            destination.innerHTML = source.innerHTML;
          }
          const modileDestination = document.getElementById(mobileId);
          const modileSource = html.getElementById(mobileId);
          if (modileSource && modileDestination) {
            modileDestination.innerHTML = modileSource.innerHTML;
          }
          const price = document.getElementById(
            `price-${this.dataset.section}`
          );

          if (price) price.classList.remove("visibility-hidden");

          if( this.currentVariant ) {
            this.toggleAddButton(
              !this.currentVariant.available,
              window.variantStrings.soldOut,
              salePrice
            );
            this.toogleOOSMessage(!this.currentVariant.available);
            this.toggleBackorderMessage(!this.currentVariant.available);
          }


        }

        if (
          document.querySelector(".product-template") &&
          document.querySelector("quantity-input")
        ) {
          document.querySelector("quantity-input").classList.remove("pe-none");
        }
        if (document.querySelector(".sticky-atc, .subscription-sticky-atc")) {
          /**For price section*/
          let stickyBottomTotalPrice = document.getElementById(
            "stickyBottomTotalPrice"
          );
          let pdpPwwtotalPrice = document.querySelector(
            ".pdpPww-total-price__js"
          );
          if (stickyBottomTotalPrice != null && pdpPwwtotalPrice != null) {
            let pdpTotalPrice = pdpPwwtotalPrice.innerHTML;
            stickyBottomTotalPrice.innerHTML = pdpTotalPrice;
          }
        }

        if (
          document.querySelectorAll(".pdpPww-total-price-clone__js").length > 0
        ) {
          document
            .querySelectorAll(".pdpPww-total-price-clone__js")
            .forEach((pdpPwwtotalPriceClone) => {
              let pdpPwwtotalPrice = document.querySelector(
                ".pdpPww-total-price__js"
              );
              if (pdpPwwtotalPriceClone && pdpPwwtotalPrice != null) {
                pdpPwwtotalPriceClone.innerHTML = pdpPwwtotalPrice.innerHTML;
              }
              if(document.querySelector("bundled-product"))
                pdpPwwtotalPriceClone.querySelector("span.your-total-text").textContent = "Bundle Total:";
            });
        }
      });
  }

  yourTotalSectionUpdate(salePrice, regularPrice) {
    let salePriceWithoutCurrency = salePrice.replace("$", "");
    let regularPriceWithoutCurrency = regularPrice.replace("$", "");
    var incrementValue = 1;

    if (
      this.closest(".product__info-container").querySelector(".quantity__input")
    ) {
      incrementValue = this.closest(".product__info-container").querySelector(
        ".quantity__input"
      ).value;
    }
    salePriceWithoutCurrency = parseFloat(
      incrementValue * salePriceWithoutCurrency.replace("$", "")
    );

    // salePriceWithoutCurrency = salePriceWithoutCurrency.toFixed(0);
    salePriceWithoutCurrency = salePriceWithoutCurrency
      .toFixed(2)
      .replace(/\.00$/, "");
    regularPriceWithoutCurrency = parseFloat(
      incrementValue * regularPriceWithoutCurrency.replace("$", "")
    );

    // regularPriceWithoutCurrency = regularPriceWithoutCurrency.toFixed(0);
    regularPriceWithoutCurrency = regularPriceWithoutCurrency
      .toFixed(2)
      .replace(/\.00$/, "");
    if (salePriceWithoutCurrency == regularPriceWithoutCurrency) {
      document
        .querySelector(".pdpPww-total-price__js")
        .querySelector(
          ".renderPrice .price__regular .price-item--regular"
        ).innerHTML = "$" + regularPriceWithoutCurrency;

      document.querySelector(".pdpPww-total-price__js")
        .querySelector(
          ".renderPrice .price__sale .price-item--regular"
        ).innerHTML = "$" + regularPriceWithoutCurrency;

      document
        .querySelector(".pdpPww-total-price__js")
        .querySelector(
          ".renderPrice .price__sale .price-item--sale"
        ).innerHTML = "$" + salePriceWithoutCurrency;
      document
        .querySelector(".pdpPww-total-price__js")
        .querySelector(".renderPrice + .price-saved-badge")
        .classList.add("d-none");
    } else {
      document
        .querySelector(".pdpPww-total-price__js")
        .querySelector(
          ".renderPrice .price__regular .price-item--regular"
        ).innerHTML = "$" + regularPriceWithoutCurrency;

      document
        .querySelector(".pdpPww-total-price__js")
        .querySelector(
          ".renderPrice .price__sale .price-item--regular"
        ).innerHTML = "$" + regularPriceWithoutCurrency;
      document
        .querySelector(".pdpPww-total-price__js")
        .querySelector(
          ".renderPrice .price__sale .price-item--sale"
        ).innerHTML = "$" + salePriceWithoutCurrency;
      document
        .querySelector(".pdpPww-total-price__js")
        .querySelector(".renderPrice + .price-saved-badge").innerHTML =
        "$" +
        (regularPriceWithoutCurrency - salePriceWithoutCurrency)
          .toFixed(2)
          .replace(/\.00$/, "") +
        " Savings";
      document
        .querySelector(".pdpPww-total-price__js")
        .querySelector(".renderPrice + .price-saved-badge")
        .classList.remove("d-none");
    }
  }

  toggleAddButton(disable = true, text, salePrice = "", modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector(
      '[name="add"] span.product-price_js'
    );
    const addButtonPrice = addButton.querySelector("span.price-item");
    const mainTitle = this.currentVariant.name.split("-")[0];
    const addToRegistry = document.getElementById("addToRegistry");
    var addToRegistryTitle = mainTitle;
    if (this.currentVariant.option2 != null) {
      addToRegistryTitle =
        addToRegistryTitle + " / " + this.currentVariant.option2;
    }
    if (this.currentVariant.option1 != null) {
      addToRegistryTitle =
        addToRegistryTitle + " / " + this.currentVariant.option1;
    }
    addToRegistry.setAttribute("data-title", addToRegistryTitle);
    addToRegistry.setAttribute("data-available", this.currentVariant.available);
    addToRegistry.setAttribute("data-barcode", this.currentVariant.barcode);
    addToRegistry.setAttribute("data-sku", this.currentVariant.sku);
    addToRegistry.setAttribute("data-option1", this.currentVariant.option1);
    addToRegistry.setAttribute("data-option2", this.currentVariant.option2);

    if (salePrice != "") {
      addToRegistry.setAttribute("data-price", `${salePrice}`);
    }

    if (!addButton) return;

    // const incrementValue =
    if (addButtonPrice && salePrice) {
      const incrementValue = this.closest(
        ".product__info-container"
      ).querySelector(".quantity__input").value;
      salePrice = parseFloat(incrementValue * salePrice.replace("$", ""));
      salePrice = salePrice.toFixed(2);
      addButtonPrice.innerHTML = `$${salePrice}`;
      // addToRegistry.setAttribute("data-price", `${salePrice}`);
    }

    let addCartBtnSimulator = document.querySelector(
      ".subscription-sticky-atc #js-nextSimulator"
    );
    let stickyAddButtonText = '';
    let stickyAtcButton = document.querySelector(".js-sticky-atc");
    if (stickyAtcButton)
      stickyAddButtonText = stickyAtcButton.querySelector('span.product-price_js');

    if (disable) {
      let addCartBtn = addButtonText.closest("#add-to-cart-main-button");
      if (addCartBtn) {
        let enableBackInStock = addCartBtn.dataset.enableoutstock;
        if (enableBackInStock == "true") {
          enableBackInStock = true;
        } else {
          enableBackInStock = false;
        }
        if (text) text = addCartBtn.dataset.outstock;
        if (!enableBackInStock) {
          addButton.setAttribute("disabled", "disabled");
          if (addCartBtnSimulator) {
            addCartBtnSimulator.innerHTML = "Sold Out";
            addCartBtnSimulator.setAttribute("disabled", "disabled");
          }
        } else {
        }
        if (text) {
          addButtonText
            .querySelector("span.klaviyo-bis-trigger")
            .classList.remove("d-none");
          addButtonText
            .querySelector("span.js-main-button-span")
            .classList.add("d-none");
          addCartBtn.classList.add("btn--gray");

          if (stickyAtcButton){
            stickyAddButtonText
              .querySelector("span.klaviyo-bis-trigger")
              .classList.remove("d-none");
            stickyAddButtonText
              .querySelector("span.js-main-button-span")
              .classList.add("d-none");
            stickyAtcButton.classList.add("btn--gray");
          }
        }
      }
      if (text) {
        addButtonText.querySelector("span.klaviyo-bis-trigger").textContent = text;
        if (stickyAddButtonText) {
          stickyAddButtonText.querySelector("span.klaviyo-bis-trigger").textContent = window.variantStrings.soldOut;
        }
      }
    } else {
      addButtonText
        .querySelector("span.klaviyo-bis-trigger")
        .classList.add("d-none");
      addButtonText
        .querySelector("span.js-main-button-span")
        .classList.remove("d-none");
      addButton.removeAttribute("disabled");

      addButtonText.querySelector("span.js-main-button-span").textContent =
        window.variantStrings.addToCart;
      addButton.classList.remove("btn--gray");

      if (stickyAtcButton){
        stickyAtcButton.classList.remove("btn--gray");
      }

      if (stickyAddButtonText) {
        stickyAddButtonText
          .querySelector("span.klaviyo-bis-trigger")
          .classList.add("d-none");
        stickyAddButtonText
          .querySelector("span.js-main-button-span")
          .classList.remove("d-none");

        stickyAddButtonText.querySelector(
          "span.js-main-button-span"
        ).textContent = window.variantStrings.addToCart;
      }

      if (addCartBtnSimulator) {
        addCartBtnSimulator.innerHTML = "Add to cart";
        addCartBtnSimulator.removeAttribute("disabled");
      }
    }

    let addCartBtnSimulatorNormal = document.querySelector(
      "#stickyBottomTotalPrice + button"
    );
    if (disable) {
      if (addCartBtnSimulatorNormal) {
        addCartBtnSimulatorNormal.innerHTML = "Sold Out";
        addCartBtnSimulatorNormal.setAttribute("disabled", "disabled");
      }
    } else {
      if (addCartBtnSimulatorNormal) {
        addCartBtnSimulatorNormal.innerHTML = "Add to cart";
        addCartBtnSimulatorNormal.removeAttribute("disabled");
      }
    }

    if (this.currentVariant.id) {
      addToRegistry.setAttribute("data-variantid", this.currentVariant.id);
    }

    if (!modifyClass) return;
  }

  toogleOOSMessage(disable = true, hide = false) {
    const outOfStockMessage = document.getElementById("out-of-stock-message");
    const inStockMessage = document.getElementById("in-stock-message");

    const backOrderBlock = document.getElementById("backorder-message");

    if (!outOfStockMessage || !inStockMessage) return;

    if (hide) {
      outOfStockMessage.classList.add("d-none");
      inStockMessage.classList.add("d-none");
    } else if (disable) {
      outOfStockMessage.classList.remove("d-none");
      inStockMessage.classList.add("d-none");
      backOrderBlock.classList.add("d-none");
    } else {
      outOfStockMessage.classList.add("d-none");
      inStockMessage.classList.remove("d-none");
      backOrderBlock.classList.add("d-none");
    }
  }

  toggleBackorderMessage() {
    const productSelectedVariant = document.querySelectorAll(
      "#total-variant__js li"
    );

    if (productSelectedVariant.length === 0) return;

    const backOrderBlock = document.getElementById("backorder-message");
    if (!backOrderBlock) return;

    if (!this.currentVariant || !this.currentVariant.id) return;

    productSelectedVariant.forEach((variant) => {
      const backOrderMessage = variant.dataset.vbackordermessage;
      const variantId = variant.dataset.vid;

      if (backOrderMessage && this.currentVariant.id == variantId) {
        if (backOrderMessage.trim() !== "") {
          backOrderBlock.querySelector("p").textContent = backOrderMessage;
          backOrderBlock.classList.remove("d-none");
          this.toogleOOSMessage(false, true);
        } else {
          backOrderBlock.classList.add("d-none");
        }
        return;
      }
    });
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(
        this.parentNode.querySelector('[type="application/json"]').textContent
      );
    return this.variantData;
  }
}
customElements.define("variant-starts", VariantStarts);

class VariantSelects extends VariantStarts {
    constructor() {
        super();
        this.updateOptions();
        this.updateMasterId();

        setTimeout(() => {
            this.initGallery();
        }, 1000);
        this.thumbnailData = document.querySelectorAll(".thumbnail-list li");
        this.addEventListener("change", this.onVariantChange);

        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
    }
    initGallery() {
        if (this.currentVariant) {
            this.updateMedia();
        }
    }
    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, "", false);
        this.updatePickupAvailability();
        this.removeErrorMessage();
        this.updateLabel();

        if (!this.currentVariant) {
            this.toggleAddButton(true, "", true);
            this.setUnavailable();
        } else {
            this.updateMedia();
            if (document.body.classList.contains("product-template")) {
                this.updateURL();
            }
            this.updateVariantInput();
            this.renderProductInfo();
            this.updateShareUrl();
        }
    }
    updateLabel() {
        // console.log(this.options)
    }

    updateOptions() {
        this.options = Array.from(
            this.querySelectorAll("select"),
            (select) => select.value
        );
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options
                .map((option, index) => {
                    return this.options[index] === option;
                })
                .includes(false);
        });
    }
    handleize(name) {
        return name
            .toLowerCase()
            .replace(/[^\w\u00C0-\u024f]+/g, "-")
            .replace(/^-+|-+$/g, "");
    }

    updateMedia() {
        //aayush chanegs
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;

        this.currentVariantOptionLowercase = this.currentVariant.options.map(
            (list) => {
                return this.handleize(list.trim().toLowerCase());
            }
        );

        this.currentVariantTitle = this.currentVariantOptionLowercase.join("|");
        const mediaGallery = document.getElementById(
            `MediaGallery-${this.dataset.section}`
        );
        if (mediaGallery) {
          mediaGallery.setActiveMedia(
            `${this.dataset.section}-${this.currentVariant.featured_media.id}`, true
          );
        }

        this.matchedData = Array(...this.thumbnailData).map((thumbs) => {
            thumbs.style.display = "none";
            var altImages = thumbs
                .querySelector("img")
                .getAttribute("data-alt");
            if (thumbs.classList.contains("js-newGallery")) {
                var altImages = thumbs
                    .querySelector("img")
                    .getAttribute("data-alt");
            } else if (altImages == null) {
                var altImages = thumbs.querySelector("img").getAttribute("alt");
            }
            const imagesAlts = altImages.split(",");

            if (
                imagesAlts.includes(
                    this.currentVariantOptionLowercase.join("|")
                )
            ) {
                thumbs.style.display = "block";
                // return thumbs;
            }
        });
        // this.matchedData = this.matchedData.filter(x => x !== undefined);
        // this.matchedDataHtml = this.matchedData.map( el => el.outerHTML )

        // console.log(this.matchedDataHtml);
        // document.querySelector('.thumbnail-list').innerHTML = this.matchedDataHtml;
        // document.querySelector('.thumbnail-list').textContent = this.matchedData
        // console.log(this.matchedData)
        this.matchedData = this.matchedData.filter((x) => x !== undefined);
        this.matchedDataHtml = this.matchedData.map((el) => el.outerHTML);

        const modalContent = document.querySelector(
            `#ProductModal-${this.dataset.section} .product-media-modal__content`
        );
        const newMediaModal = modalContent.querySelector(
            `[data-media-id="${this.currentVariant.featured_media.id}"]`
        );
        // modalContent.prepend(newMediaModal);
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === "false") return;
        window.history.replaceState(
            {},
            "",
            `${this.dataset.url}?variant=${this.currentVariant.id}`
        );
    }

    updateShareUrl() {
        const shareButton = document.getElementById(
            `Share-${this.dataset.section}`
        );
        if (!shareButton) return;
        shareButton.updateUrl(
            `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
        );
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(
            `#product-form-${this.dataset.section}, #product-form-installment`
        );
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event("change", { bubbles: true }));
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector(
            "pickup-availability"
        );
        if (!pickUpAvailability) return;

        if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute("available");
            pickUpAvailability.innerHTML = "";
        }
    }

    removeErrorMessage() {
        const section = this.closest("section");
        if (!section) return;

        const productForm = section.querySelector("product-form");
        if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
        fetch(
            `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
        )
            .then((response) => response.text())
            .then((responseText) => {
                const id = `price-${this.dataset.section}`;
                const mobileId = `price-${this.dataset.section}-mobile`;
                const html = new DOMParser().parseFromString(
                    responseText,
                    "text/html"
                );
                const destination = document.getElementById(id);
                const source = html.getElementById(id);

                if (source && destination) {
                    destination.innerHTML = source.innerHTML;
                }
                const modileDestination = document.getElementById(mobileId);
                const modileSource = document.getElementById(mobileId);
                if (modileSource && modileDestination) {
                    modileDestination.innerHTML = modileSource.innerHTML;
                }

                const price = document.getElementById(
                    `price-${this.dataset.section}`
                );

                if (price) price.classList.remove("visibility-hidden");

                this.toggleAddButton(
                    !this.currentVariant.available,
                    window.variantStrings.soldOut
                );
            });
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(
            `product-form-${this.dataset.section}`
        );
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');

        if (!addButton) return;

        if (disable) {
            addButton.setAttribute("disabled", "disabled");
            if (text) addButtonText.textContent = text;
        } else {
            addButton.removeAttribute("disabled");
            addButtonText.textContent = window.variantStrings.addToCart;
        }

        if (!modifyClass) return;
    }

    setUnavailable() {
        const button = document.getElementById(
            `product-form-${this.dataset.section}`
        );
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add("visibility-hidden");
    }

    getVariantData() {
        this.variantData =
            this.variantData ||
            JSON.parse(
                this.parentNode.querySelector('[type="application/json"]')
                    .textContent
            );
        return this.variantData;
    }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      const checkedData = Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
      fieldset.querySelector("legend .selected").innerHTML = checkedData;
      return checkedData;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class PCardVariant extends HTMLElement {
    constructor() {
        super();
        this.updateOptions();
        this.updateMasterId();

        this.addEventListener("change", this.onVariantChange);
        this.labelClick();
        this.productId = this.dataset.section;
        if (this.closest(".product-design-feature") != null) {
            this.querySelector("fieldset").addEventListener(
                "mouseover",
                this.hoverInVariantColor.bind(this)
            );
            this.querySelector("fieldset").addEventListener(
                "mouseleave",
                this.hoverOutVariantColor.bind(this)
            );
        } else {
            if (
                this.closest(".card-wrapper").querySelector(".card__media") !=
                null
            ) {
                this.closest(".card-wrapper")
                    .querySelector(".card__media")
                    .addEventListener(
                        "mouseover",
                        this.onVariantHover.bind(this)
                    );
                this.closest(".card-wrapper")
                    .querySelector(".card__media")
                    .addEventListener(
                        "mouseleave",
                        this.variantHoverOut.bind(this)
                    );
            }
        }
        this.hideVariant(this.currentVariant);
    }

    enableFinalSaleBadge(){
      if (!this.currentVariant) return;
      const totalVariant = this.querySelector(`.pcard-variants__final_sale_badge li[data-final-vid="${this.currentVariant.id}"]`);
      if(!totalVariant) return;
      const cardWrapper = this.closest(".card-wrapper");
      const finalSaleBadgeBlock = cardWrapper.querySelector(".product-final-sale");

      finalSaleBadgeBlock.innerHTML = totalVariant.innerHTML;
    }

    enableBadge() {
      if (!this.currentVariant) return;
      const totalVariant = this.querySelectorAll(".pcard-variants__js li");
      const cardWrapper = this.closest(".card-wrapper");
      const showBadgeBlock = cardWrapper.querySelector(".show-badge");

      if (!showBadgeBlock) return;

      showBadgeBlock.classList.add("d-none");
      showBadgeBlock.classList.remove("d-flex");

      if (!this.currentVariant || !this.currentVariant.id) return;

      totalVariant.forEach((variant) => {
        const showBadge = variant.dataset.vbadge;
        const variantId = variant.dataset.vid;

        if (showBadge=="True" && this.currentVariant.id == variantId) {
            if(showBadgeBlock.classList.contains("d-none")){
              showBadgeBlock.classList.remove("d-none");
              showBadgeBlock.classList.add("d-flex");
            }
          return;
        }
      });
    }

    hoverInVariantColor(event) {
        if (event.target.tagName == "LABEL") {
            var parentElement = event.target.closest(".product-design-feature");
            const pngImages = parentElement.querySelectorAll(
                ".product-design-feature__wrap .card__media img"
            );
            this.removeClassByPrefix(parentElement, "background-");
            pngImages.forEach((img) => {
                img.classList.add("d-none");
                img.classList.remove("show");
                if (event.target.innerText == img.dataset.variantColor) {
                    img.classList.add("showing");
                    setTimeout(function () {
                        img.classList.remove("showing");
                        img.classList.add("show");
                    }, 500);

                    img.classList.remove("d-none");
                    var addSectionClass =
                        "background-" +
                        img.dataset.variantColor
                            .replace(" ", "-")
                            .toLowerCase();
                    parentElement.classList.add(addSectionClass);
                }
            });
        }
    }

    hoverOutVariantColor(event) {
        var parentElement = event.target.closest(".product-design-feature");
        const pngImages = parentElement.querySelectorAll(
            ".product-design-feature__wrap .card__media img"
        );
        const activeVariantColor = parentElement.querySelector(
            ".product-design-feature__wrap pcard-variant .color-variants input:checked"
        ).value;
        pngImages.forEach((img) => {
            if (activeVariantColor == img.dataset.variantColor) {
                img.classList.remove("d-none");
                parentElement.classList.add(
                    "background-" + activeVariantColor.toLowerCase()
                );
            } else {
                img.classList.add("d-none");
                img.classList.remove("show");
                var addSectionClass =
                    "background-" +
                    img.dataset.variantColor.replace(" ", "-").toLowerCase();
                parentElement.classList.remove(addSectionClass);
            }
        });
    }

    onVariantHover(e) {
        let parentElm = e.target.closest(`.card-wrapper`);
        var variants = parentElm.querySelectorAll("pcard-variant fieldset");
        if (variants[0]) {
            var hoveredTitle = variants[0].querySelector("input:checked")?.value;
        }
        if (variants[1] != undefined) {
            let checkedBundle =
                variants[1].querySelector("input:checked")?.value;
            hoveredTitle = hoveredTitle + " / " + checkedBundle;
        }
        let previewImage = parentElm.querySelector(
            `[data-imgTitle="${hoveredTitle}"]`
        );
        // let allVariants = parentElm.querySelector('.pcard-variants__js');
        // let hoverItem = allVariants.querySelector(`[data-vtitle="${hoveredTitle}"]`);
        if (previewImage) {
            parentElm
                .querySelector(".card__media img")
                .classList.add("default-img");
            e.target.classList.add("hide");
            previewImage.classList.remove("hide");
            previewImage.classList.add("preview-img");
            // let vpreviewImage = hoverItem.dataset.vpreviewimage;
            // if (vpreviewImage == '') {
            //   vpreviewImage = hoverItem.dataset.vimage;
            // }
            // let imgTag = parentElm.querySelector(".card__media img");
            // imgTag.setAttribute(
            //         "src",
            //         vpreviewImage
            //     );
            // imgTag.setAttribute("srcset", "");
            // imgTag.setAttribute(
            //         "srcset",
            //         vpreviewImage
            //     );
        } else {
            parentElm
                .querySelector(".card__media img")
                .classList.remove("default-img");
        }
    }
    variantHoverOut(e) {
        var allVImages = e.target.querySelectorAll("img");
        allVImages.forEach((img) => {
            if (img.classList.contains("hover-image")) {
                img.classList.add("hide");
            } else {
                img.classList.remove("hide");
            }
        });
        // let allVariants = parentElm.querySelector('pcard-variant .pcard-variants__js');
        // let variantItem = allVariants.querySelector(`[data-vid="${this.currentVariant.id}"]`);
        // let vpreviewImage = variantItem.dataset.vimage;
        // let imgTag = parentElm.querySelector(".card__media img");

        // imgTag.setAttribute(
        //         "src",
        //         vpreviewImage
        //     );
        // imgTag.setAttribute("srcset", "");
        // imgTag.setAttribute(
        //         "srcset",
        //         vpreviewImage
        //     );
        // imgTag.classList.remove("show");
        // imgTag.classList.add("hoverout");
        // setTimeout(function () {
        //   imgTag.classList.remove("hoverout");
        // }, 500);
    }
    onVariantChange(e) {
        this.updateOptions();
        this.updateMasterId();
        this.enableBadge();

        if (this.currentVariant) {
            this.updateMedia();
            let current =
                e.target.nextElementSibling.classList.contains(
                    "noPriceUpdate__js"
                );
            if (current) {
                return false;
            } else {
                this.renderProductInfo();
            }
            this.updateBabylist(this.currentVariant);

            //in case of using cards in tabbed-grid
            this.updateCardVariantID(this.currentVariant);
            this.enableFinalSaleBadge();
        }
        this.hideVariant(this.currentVariant);
        this.forcedSetActiveInSecondOption(e);
    }

    updateCardVariantID(currentVariant) {
        const cardWrapper = this.closest(".card-with-cart-button ");
        if (!cardWrapper) return;
        const variantIdInput = cardWrapper.querySelector(
            '.product-form [name="id"][type="hidden"]'
        );
        const cardInnerLink = cardWrapper.querySelector('.card__inner a');
        const cardContentLink = cardWrapper.querySelector('.card__content a');
        const learnAddToLink = cardWrapper.querySelector(
            '.learn-addto-link'
        );
        const mainButtonSpan = cardWrapper.querySelector(".product-form__buttons button .js-main-button-span")

        if (variantIdInput) {
          variantIdInput.value = currentVariant.id;
        }

        if(cardInnerLink){
          cardInnerLink.setAttribute("href", `${this.dataset.url}?variant=${this.currentVariant.id}`);
        }

        if(cardContentLink){
          cardContentLink.setAttribute("href", `${this.dataset.url}?variant=${this.currentVariant.id}`);
        }

        if(learnAddToLink){
          learnAddToLink.setAttribute("href", `${this.dataset.url}?variant=${this.currentVariant.id}`);
        }
        if(!currentVariant.available) {
          cardWrapper.querySelector(".product-form__buttons button")?.setAttribute("disabled", "disabled");
          if (mainButtonSpan) {
            mainButtonSpan.innerText = "Sold Out";
          }
        }
        else {
          cardWrapper.querySelector(".product-form__buttons button")?.removeAttribute("disabled");
          if(mainButtonSpan) {
            mainButtonSpan.innerText = "Add to Cart";
          }
        }
    }

    updateOptions() {
        this.optionsSelect = this.optionsRadio = [];
        if (this.querySelector("select")) {
            this.optionsSelect = Array.from(
                this.querySelectorAll("select"),
                (select) => select.value
            );
        }

        if (this.querySelector("fieldset")) {
            const fieldsets = Array.from(this.querySelectorAll("fieldset"));

            this.optionsRadio = fieldsets.map((fieldset) => {
                const checkedData = Array.from(
                    fieldset.querySelectorAll("input")
                ).find((radio) => {
                    return radio.checked;
                })?.value;

                fieldset.querySelector("legend .selected").innerHTML =
                    checkedData;
                return checkedData;
            });
        }
        // if( this.firstElementChild.classList.contains('variation-dropdown') ) {
        //   this.options = this.optionsSelect.concat( this.optionsRadio );
        // } else {
        //   this.options = this.optionsRadio.concat( this.optionsSelect );
        // }
        this.options = this.optionsRadio.concat(this.optionsSelect);
    }
    updateMasterId() {
        // console.log(this.getVariantData());
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options
                .map((option, index) => {
                    return this.options[index] === option;
                })
                .includes(false);
        });
    }
    handleize(name) {
        return name
            .toLowerCase()
            .replace(/[^\w\u00C0-\u024f]+/g, "-")
            .replace(/^-+|-+$/g, "");
    }
    updateMedia() {
        //aayush chanegs

        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;
        this.currentVariantOptionLowercase = this.currentVariant.options.map(
            (list) => {
                return this.handleize(list.trim().toLowerCase());
            }
        );
        this.currentVariantTitle = this.currentVariantOptionLowercase.join("|");

        /** update bg color for product design feature section*/
        var parentElement = this.closest(".product-design-feature");
        if (parentElement !== null) {
            this.removeClassByPrefix(parentElement, "background-");
            var addSectionClass =
                "background-" +
                this.currentVariant.option1.replace(" ", "-").toLowerCase();
            parentElement.classList.add(addSectionClass);
            parentElement.querySelector('[name="id"]').value =
                this.currentVariant.id;
            const pngImages =
                this.closest(".card-wrapper").querySelectorAll(
                    ".card__media img"
                );
            const activeVariant = parentElement.querySelector(
                "pcard-variant .color-variants input:checked"
            ).value;
            pngImages.forEach((img) => {
                img.classList.add("d-none");
                if (activeVariant == img.dataset.variantColor) {
                    img.classList.remove("d-none");
                }
            });
        } else {
            let imgSrc = this.currentVariant.featured_media.preview_image.src;
            this.closest(".card-wrapper")
                .querySelector(".card__media img")
                .setAttribute("src", imgSrc);
            this.closest(".card-wrapper")
                .querySelector(".card__media img")
                .setAttribute("srcset", "");
            this.closest(".card-wrapper")
                .querySelector(".card__media img")
                .setAttribute("srcset", imgSrc);
        }
    }
    removeClassByPrefix(el, prefix) {
        var regx = new RegExp("\\b" + prefix + ".*?\\b", "g");
        if (el != undefined) {
            el.className = el.className.replace(regx, "");
        }
        return el;
    }
    //&section_id=${this.dataset.section}__main
    renderProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}`)
            .then((response) => response.text())
            .then((responseText) => {
                const id = `price-${this.dataset.section}__main`;

                const html = new DOMParser().parseFromString(
                    responseText,
                    "text/html"
                );
                const source = html.getElementById(id);
                let productID;
                if (this.currentVariant.featured_image) {
                    productID = this.currentVariant.featured_image.product_id;
                } else {
                    productID = this.productId;
                }

                const cardId = `price-card-${productID}`;
                const destination = this.closest(".card-wrapper").querySelector(
                    `#${cardId}`
                );

                if (source && destination) {
                    destination.innerHTML = source.innerHTML;
                }
                // destination.innerHTML = source.innerHTML;

                const price = document.getElementById(
                    `price-${this.dataset.section}`
                );

                if (price) price.classList.remove("visibility-hidden");
            });
    }
    hideVariant(variantObj = null) {
        const totalVariant = this.querySelectorAll(".pcard-variants__js li");
        var variantHide = "false";
        var index = 0;
        let colorSwatchesini = this.querySelectorAll(
          ".color-variants label"
        );
        if(colorSwatchesini.length > 1) {
          colorSwatchesini.forEach((colorLabel) => {
            colorLabel.classList.add("d-none");
          });
        }

        totalVariant.forEach((item) => {
          let title = item.dataset.vtitle;
          let titleArray = title.split("@");

          if (variantObj != null && titleArray[1]) {
            /** if clicked kit**/
            if (titleArray[1].trim() == variantObj.option2) {
              variantHide = item.dataset.vhide;
              let colorSwatches = this.querySelectorAll(
                ".color-variants label, .bundle-variants .bundle--texture"
              );
              if (this.querySelector(".color-variants, .bundle-variants") != null) {
                colorSwatches.forEach((colorLabel) => {
                  var color = colorLabel.querySelector("span").innerText;
                  if (titleArray[0].trim() == color) {

                      if (variantHide == "true") {
                          colorLabel.classList.add("d-none");
                      } else {
                          index++;
                          if (index < 4) {
                              colorLabel.classList.remove("d-none");
                          } else {
                              if (
                                  !this.classList.contains(
                                      "full_variant_show"
                                  )
                              ) {
                                  colorLabel.classList.add("d-none");
                              }
                          }
                      }
                  }
                });
              }
            }
            if(!this.querySelector('.first_active__js')){
              if (this.querySelector("[data-variantColorQty]") != null) {
                if (index > 3) {
                  this.querySelector("[data-variantColorQty]").innerHTML =
                        "+" + (index - 3);
                } else {
                  this.querySelector("[data-variantColorQty]").innerHTML =
                        "";
                }
              }
            }

            /**  if clicked swatches or dropdown **/
            if (titleArray[0].trim() == variantObj.option1) {
              let kitPills = document.querySelectorAll(
                  ".bundle-variants label"
              );
              if (this.querySelector(".bundle-variants") != null) {
                kitPills.forEach((kitPill) => {
                  variantHide = item.dataset.vhide;
                  var kit = kitPill.dataset.title;
                  if (titleArray[1].trim() == kit) {
                    if (variantHide == "true") {
                      kitPill.classList.add("d-none");
                    } else {
                      kitPill.classList.remove("d-none");
                    }
                  }
                });
              }

              if(this.querySelector(".color-variants") != null){
                let colorSwatchesLevel = this.querySelectorAll(
                  ".color-variants label"
                );

                colorSwatchesLevel.forEach((colorLabel) => {
                  var color =
                      colorLabel.querySelector("span").innerText;

                  if (titleArray[1].trim() == color) {
                    if (variantHide == "true") {
                      colorLabel.classList.add("d-none");
                    } else {
                      index++;
                      if (index < 4) {
                        colorLabel.classList.remove("d-none");
                      } else {
                        if (!this.classList.contains("full_variant_show")) {
                          colorLabel.classList.add("d-none");
                        }
                      }
                    }
                  }
                });

                if(this.querySelector('.first_active__js')){
                  if (this.querySelector("[data-variantColorQty]") != null) {
                    if (index > 3) {
                      this.querySelector(".color-variants [data-variantColorQty]").innerHTML =
                            "+" + (index - 3);
                    } else {
                      this.querySelector(".color-variants [data-variantColorQty]").innerHTML =
                            "";
                    }
                  }
                }

              }
            }
          } else if (variantObj != null && titleArray[0]) {
              /** if clicked kit**/
              variantHide = item.dataset.vhide;
              let colorSwatches = this.querySelectorAll(
                  ".color-variants label, .bundle-variants .bundle--texture"
              );
              if (this.querySelector(".color-variants, .bundle-variants") != null) {
                colorSwatches.forEach((colorLabel) => {
                  var color = colorLabel.querySelector("span").innerText;

                  if (titleArray[0].trim() == color) {
                      if (variantHide == "true") {
                        colorLabel.classList.add("d-none");
                      } else {
                        index++;
                        if (index < 4) {
                          colorLabel.classList.remove("d-none");
                        } else {
                          if (
                              !this.classList.contains(
                                  "full_variant_show"
                              )
                          )
                            colorLabel.classList.add("d-none");
                        }
                      }
                  }
                });
              }
              if (this.querySelector("[data-variantColorQty]") != null) {
                if (index > 3) {
                  this.querySelector("[data-variantColorQty]").innerHTML =
                        "+" + (index - 3);
                } else {
                  this.querySelector("[data-variantColorQty]").innerHTML =
                        "";
                }
              }
          }
        });
    }

    forcedSetActiveInSecondOption(e) {
      let variantStartElm = e.target.closest('pcard-variant');
      let firstActiveJs = variantStartElm?.querySelector('.first_active__js');

      //if there is required to forced to change variant of this option active
      if(firstActiveJs) {
        let closestFieldset = e.target.closest('fieldset');
        if(closestFieldset && closestFieldset.classList.contains('bundle-variants')) {
          let allVariant = firstActiveJs.querySelectorAll('.bv-color-swatch-wrapper');
          let activeVariant = firstActiveJs.querySelectorAll('.bv-color-swatch-wrapper:not(.d-none)');
          if(!this.currentVariant) {
            for(let i = 0; i < allVariant.length; i++) {
              if(!this.currentVariant) {
                allVariant[i].querySelector('label').click();
              }
            }
          } else {
            let hasChecked = false;
            activeVariant.forEach( (act) => {
              if(!act.querySelector("input:checked"))
                hasChecked = true;
            });
            if(hasChecked === false)
              activeVariant[0].querySelector('label').click();
          }
        }
      }
    }
    getVariantData() {
        this.variantData =
            this.variantData ||
            JSON.parse(
                this.parentNode.querySelector('[type="application/json"]')
                    .textContent
            );
        return this.variantData;
    }

    labelClick() {
        this.querySelectorAll("label").forEach((item) => {
            item.addEventListener("click", (e) => {
                e.preventDefault();
                item.previousElementSibling.click();
                // item.previousElementSibling.dispatchEvent(new Event('change', { bubbles: true }));
                // item.previousElementSibling.dispatchEvent('change')
            });
        });
    }

    updateBabylist() {
        if (this.closest(".product-with-registry")) {
            let productCard = this.closest(".product-with-registry");

            const mainTitle = this.currentVariant.name.split("-")[0];
            const addToRegistry = productCard.querySelector(".addToRegistry");
            if (!addToRegistry) return;
            var addToRegistryTitle = mainTitle;
            if (this.currentVariant.option2 != null) {
                addToRegistryTitle =
                    addToRegistryTitle + " / " + this.currentVariant.option2;
            }
            if (this.currentVariant.option1 != null) {
                addToRegistryTitle =
                    addToRegistryTitle + " / " + this.currentVariant.option1;
            }
            addToRegistry.setAttribute("data-title", addToRegistryTitle);
            if (this.currentVariant.id) {
                addToRegistry.setAttribute(
                    "data-variantid",
                    this.currentVariant.id
                );
            }
            var imageSrc = this.currentVariant.featured_image.src;
            if (imageSrc) {
                addToRegistry.setAttribute("data-img", imageSrc);
            }
            var salePrice = this.currentVariant.price;
            if (salePrice) {
                salePrice = parseFloat(salePrice) / parseInt(100);
                salePrice = salePrice.toFixed(2);

                // addToRegistry.setAttribute("data-price", `$${salePrice}`);
            }
            var productVariantId = this.currentVariant.id;
            if (productVariantId) {
                var productUrl = addToRegistry.getAttribute("data-url");
                productUrl =
                    productUrl.split("?")[0] + "?variant=" + productVariantId;
                addToRegistry.setAttribute("data-url", productUrl);

                var productCardUrl = productCard.querySelector(
                    ".product_image_card a"
                );
                productCardUrl?.setAttribute("href", productUrl);
            }
        }
    }
}
customElements.define("pcard-variant", PCardVariant);

class PCardSubscribe extends HTMLElement {
    constructor() {
        super();
        let mediaWrapper = this.closest(".card-wrapper").querySelector(
            ".card__media .media"
        );
        mediaWrapper.classList.add("is-subscribe-block");
        let susbscribeImageElement = (this.subscribeImage = new Image());
        susbscribeImageElement.classList.add("d-none", "subscribe-image-hide");
        susbscribeImageElement.setAttribute(
            "data-subscribe-image-checked",
            "subscribe-save"
        );
        susbscribeImageElement.setAttribute(
          "alt",
          ""
        );
        mediaWrapper.appendChild(susbscribeImageElement);

        this.updateOptions();
        this.addEventListener("change", this.onVariantChange);
        this.labelClick();
        this.productId = this.dataset.section;
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMedia();
    }

    updateOptions() {
        this.optionsRadio = [];

        if (this.querySelector("fieldset")) {
            const fieldsets = Array.from(this.querySelectorAll("fieldset"));
            let checkedCustomMessage;
            let checkedCustomImage;

            this.optionsRadio = fieldsets.map((fieldset) => {
                const checkedData = Array.from(
                    fieldset.querySelectorAll("input")
                ).find((radio) => {
                    return radio.checked;
                }).value;

                checkedCustomMessage = Array.from(
                    fieldset.querySelectorAll("input")
                ).find((radio) => {
                    return radio.checked;
                }).dataset.customMessageCheck;

                checkedCustomImage = Array.from(
                    fieldset.querySelectorAll("input")
                ).find((radio) => {
                    return radio.checked;
                }).dataset.customImageCheck;

                fieldset.querySelector("legend .selected").innerHTML =
                    checkedData;
                return {
                    checkedButton: checkedData,
                    checkedText: checkedCustomMessage,
                    checkedImage: checkedCustomImage,
                };
            });

            this.querySelectorAll(".js-customtext").forEach((e) => {
                if (e.dataset.customMessage == checkedCustomMessage) {
                    e.classList.remove("d-none");
                } else {
                    e.classList.add("d-none");
                }
            });
        }

        this.options = this.optionsRadio;
    }

    handleize(name) {
        return name
            .toLowerCase()
            .replace(/[^\w\u00C0-\u024f]+/g, "-")
            .replace(/^-+|-+$/g, "");
    }

    updateMedia() {
        this.optionFirst = this.options[0];
        if (
            this.optionFirst.checkedImage != undefined &&
            this.subscribeImage.dataset.subscribeImageChecked ==
                this.optionFirst.checkedText &&
            this.optionFirst.checkedImage != ""
        ) {
            this.subscribeImage.src = this.optionFirst.checkedImage;
            this.subscribeImage.classList.remove(
                "d-none",
                "subscribe-image-hide"
            );
            this.subscribeImage.classList.add("subscribe-image-show");
        } else {
            this.subscribeImage.classList.add("d-none", "subscribe-image-hide");
            this.subscribeImage.classList.remove("subscribe-image-show");
        }
    }

    removeClassByPrefix(el, prefix) {
        var regx = new RegExp("\\b" + prefix + ".*?\\b", "g");
        if (el != undefined) {
            el.className = el.className.replace(regx, "");
        }
        return el;
    }

    labelClick() {
        this.querySelectorAll("label").forEach((item) => {
            item.addEventListener("click", (e) => {
                e.preventDefault();
                item.previousElementSibling.click();
            });
        });
    }
}
customElements.define("pcard-subscribe", PCardSubscribe);
class PBundleVariant extends HTMLElement {
    constructor() {
        super();
        // this.isBundle = this.querySelector
        this.updateOptions();
        this.updateMasterId();
        this.updateVariantInput(true);
        this.addEventListener("change", this.onVariantChange);
    }
    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            // console.log(variant.title)
            // console.log(this.options[0])
            return variant.title === this.options[0];
            // return !variant.options.map((option, index) => {

            //   return this.options[index] === option;

            // }).includes(false);
        });
        // console.log('thisvariant',this.currentVariant);
    }
    handleize(name) {
        return name
            .toLowerCase()
            .replace(/[^\w\u00C0-\u024f]+/g, "-")
            .replace(/^-+|-+$/g, "");
    }
    getVariantData() {
        this.variantData =
            this.variantData ||
            JSON.parse(
                this.querySelector('[type="application/json"]').textContent
            );
        return this.variantData;
    }
    updateOptions() {
        this.optionsSelect = this.optionsRadio = [];
        if (this.querySelector("select")) {
            this.optionsSelect = Array.from(
                this.querySelectorAll("select"),
                (select) => select.value
            );
        }

        if (this.querySelector("fieldset")) {
            const fieldsets = Array.from(this.querySelectorAll("fieldset"));
            this.optionsRadio = fieldsets.map((fieldset) => {
                if (fieldset.classList.contains("multipleData")) {
                    const checkedData = Array.from(
                        fieldset.querySelectorAll("input")
                    ).find((radio) => radio.checked).dataset.value;
                    const checkedDataValue = Array.from(
                        fieldset.querySelectorAll("input")
                    ).find((radio) => radio.checked).value;
                    fieldset.querySelector("legend .selected").innerHTML =
                        checkedDataValue;
                    return checkedData;
                } else {
                    const checkedData = Array.from(
                        fieldset.querySelectorAll("input")
                    ).find((radio) => radio.checked).value;
                    fieldset.querySelector("legend .selected").innerHTML =
                        checkedData;
                    return checkedData;
                }
            });
        }
        if (this.firstElementChild.classList.contains("variation-dropdown")) {
            this.options = this.optionsSelect.concat(this.optionsRadio);
        } else {
            this.options = this.optionsRadio.concat(this.optionsSelect);
        }
        // console.log(this.options);
    }
    updateVariantInput(mediaUpdate = false) {
        const productForms = document.querySelectorAll(
            `#product-form-${this.dataset.section}, #product-form-installment`
        );
        productForms.forEach((productForm) => {
            if (productForm.querySelector(".bundle-inputs")) {
                const input = productForm.querySelector(
                    `input[data-bundle="${this.dataset.bundleSection}"]`
                );
                input.value = this.currentVariant.id;
                if (mediaUpdate) {
                    this.updateNewMedia();
                }
                input.dispatchEvent(new Event("change", { bubbles: true }));
            }
        });
    }
    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        // this.toggleAddButton(true, '', false);
        // this.updatePickupAvailability();
        // this.removeErrorMessage();
        // this.updateShippingInfo();
        // this.updateLabel();
        // console.log("vv", this.currentVariant);
        if (!this.currentVariant) {
            // console.log("variant changes");
            // this.toggleAddButton(true, '', true);
            // this.setUnavailable();
        } else {
            this.updateVariantInput();
            this.updateNewMedia(this.currentVariant.id);
            // this.updateURL();
        }
    }
    updateNewMedia() {
        const bundleParent = this.querySelector(".bundle-product-single");
        const bundleImages = bundleParent.querySelectorAll("img");
        bundleImages.forEach((element) => {
            element.classList.add("d-none");
            element.classList.remove("show");
        });
        const bundledVaraintImage = bundleParent.querySelector(
            `img[data-variant-id="${this.currentVariant.id}"]`
        );
        bundledVaraintImage.classList.remove("d-none");
        bundledVaraintImage.classList.add("show");
    }
}
customElements.define("product-bundle", PBundleVariant);

// babylist registry new js code
class LaloBabyList extends HTMLElement {
    constructor() {
        super();
        this.clickEvent();
    }
    clickEvent() {
        const registryBtn = this.querySelector(".addToRegistry");
        this.addEventListener("click", function (e) {
            e.preventDefault();
            var active_product_url = registryBtn.dataset.url;
            var main_active_product_title = registryBtn.dataset.title;
            let active_product_image = "";

            if (document.querySelector(".product__image-slider")) {
                active_product_image = document.querySelector(
                    ".product__image-slider .carousel-cell.is-selected img"
                ).src;
            } else if (
                document.querySelector(".product__media-item.is-active img")
            ) {
                active_product_image = document.querySelector(
                    ".product__media-item.is-active img"
                ).src;
            } else {
                active_product_image = registryBtn.dataset.img;
            }

            var active_product_price = registryBtn.dataset.price;
            var active_product_id = registryBtn.dataset.variantid;
            active_product_url =
                active_product_url + "?variant=" + active_product_id;

            bl.addToRegistry({
                images: active_product_image,
                price: active_product_price,
                title: main_active_product_title,
                url: active_product_url,
            });
        });
    }
}
customElements.define("lalo-registry", LaloBabyList);

class BCardVariant extends HTMLElement {
  constructor() {
    super();
    this.updateOptions();
    this.updateMasterId();
    this.addEventListener("change", this.onVariantChange);

    //this.pdpBund = new PDPBundles();
    this.productId = this.dataset.section;
    let hideFirst = false;
    if(this.querySelector('.first_active__js')){
      hideFirst = true;
    }
    this.hideVariant(this.currentVariant, hideFirst);
  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    // this.labelClick();
    this.labelClickNew(e);
    if (this.currentVariant) {
      this.updateMedia();
      let current =
        e.target.nextElementSibling.classList.contains("noPriceUpdate__js");
      if (current) {
        return false;
      } else {
        // this.renderProductInfo();
      }

      //to update add to cart value
      var selectedItems = document.getElementById("js_bundle_items");
      var bundleList = selectedItems.querySelector(".js-bundle-items");
      this.updateAddtoCartList(bundleList);
      this.addProductToStickyATC();
    }
    let hideFirst = false;
    if(this.querySelector('.first_active__js')){
      hideFirst = true;
    }
    this.hideVariant(this.currentVariant,hideFirst);
    this.forcedSetActiveInSecondOption(e);
    this.displayOOSOrBackOrder();
  }

  displayOOSOrBackOrder() {
    if(this.currentVariant) {
      let currentVariantData = this.querySelector('.bcard-variants__js')?.querySelector(`[data-vid="${this.currentVariant.id}"]`);
      let closestSection = this.closest('.pdpfwp_section__js');

      if(closestSection) {
        closestSection?.querySelector('.oos-message')?.classList.add('d-none');
        closestSection?.querySelector('.backorder-message')?.classList.add('d-none');

        if (currentVariantData?.getAttribute('data-vstock')=="true") {
          closestSection?.querySelector('.oos-message')?.classList.remove('d-none');

        } else if (currentVariantData?.getAttribute('data-vbackordermessage') != '') {
          closestSection.querySelector('.backorder-message').querySelector('.caption').innerHTML = currentVariantData.getAttribute('data-vbackordermessage');
          closestSection?.querySelector('.backorder-message')?.classList.remove('d-none');
        }
      }
    }
  }


  addProductToStickyATC = () => {
    let atcHolder = document.querySelector("#selectedBundleItems");
    if (!atcHolder) return;
    let selecteditems = document.querySelectorAll(".js_all_products .pdp_bundle");
    atcHolder.innerHTML = '';
    var imageCount = 0;

    selecteditems.forEach((item) => {
      let selectedItemImage = item.querySelectorAll("img");
      let selectedImage = '';
      let variantID = '';
      selectedItemImage.forEach((imgs, index) => {
        if ( imgs.classList.contains("show") || !imgs.classList.contains("d-none")){
          imgs.className='';
          variantID = imgs.getAttribute("data-variant-id");
          selectedImage = imgs.cloneNode(true);
        }
      });
      if (selectedImage && atcHolder && variantID) {
        if (imageCount < 4) {
          const wrapper = document.createElement("div");
          wrapper.className = "sticky-atc-img";
          wrapper.setAttribute("data-variant-id", variantID);
          wrapper.appendChild(selectedImage);
          atcHolder.appendChild(wrapper);
        }
        imageCount++;
      }
    });
    if(imageCount > 3){
      const moreButton = document.createElement("a");
      moreButton.setAttribute("tabindex", "0");
      moreButton.setAttribute("role", "button");
      moreButton.className = "more-button";
      moreButton.setAttribute("aria-label", "Click to View Bundle");
      moreButton.innerHTML = "+" + (imageCount - 4);
      atcHolder.appendChild(moreButton);
    }
  }

  updateAddtoCartList = (pitem) => {
    pitem.querySelectorAll(".pdpfwp_section__js").forEach((item) => {
      const itemValues = item.querySelector(
        '.checked[data-id="product-pdp_bundle"]'
      );
      // console.log(itemValues,'itemValues');
      //const itemVariantID = item.querySelector('img').getAttribute('data-variant-id');
      var itemVariantID = "";
      const varitantImages = item.querySelectorAll(
        ".thumb-product-card-images img"
      );
      varitantImages.forEach((imgs) => {
        if (
          imgs.classList.contains("show") ||
          !imgs.classList.contains("d-none")
        )
          itemVariantID = imgs.getAttribute("data-variant-id");

      });
      this.createInputData(
        itemValues.getAttribute("data-index"),
        itemVariantID,
        null
      );




      // this.pdpPwwPriceUpdate(itemValues, 'plus');

      // if (document.querySelector(".sticky-atc")) {
      //   this.updateStickyATCInfo();
      // }
    });
  };

  //To add to the list of add to cart form
  createInputData(num, value, qty) {
    let extraPrice = document.getElementById("product-extra-prices");
    let fieldAlreadyAdded = extraPrice.querySelector(
      `[name="items[${num}]id"]`
    );
    let fieldAlreadyAddedValue = extraPrice.querySelector(
      `[name="items[${num}]id"]`
    ).value;
    let fieldQty = extraPrice.querySelector(`[name="items[${num}]quantity"]`);
    if (fieldAlreadyAddedValue != value) {
      fieldAlreadyAdded.remove();
      var x = document.createElement("INPUT");
      x.setAttribute("type", "hidden");
      x.setAttribute("name", `items[${num}]id`);
      x.setAttribute("value", value);
      // return x;
      extraPrice.appendChild(x);
    }
    if (!fieldQty && qty != null) {
      var x = document.createElement("INPUT");
      x.setAttribute("type", "hidden");
      x.setAttribute("name", `items[${num}]quantity`);
      x.setAttribute("value", qty);
      extraPrice.appendChild(x);
    }
  }
  updateOptions() {
    this.optionsSelect = this.optionsRadio = [];
    if (this.querySelector("select")) {
      this.optionsSelect = Array.from(
        this.querySelectorAll("select"),
        (select) => select.value
      );
    }

    if (this.querySelector("fieldset")) {
      const fieldsets = Array.from(this.querySelectorAll("fieldset"));

      this.optionsRadio = fieldsets.map((fieldset) => {
        const checkedData = Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => {
            return radio.checked;
          }
        )?.value;

        fieldset.querySelector("legend .selected").innerHTML = checkedData;
        return checkedData;
      });
    }
    // if( this.firstElementChild.classList.contains('variation-dropdown') ) {
    //   this.options = this.optionsSelect.concat( this.optionsRadio );
    // } else {
    //   this.options = this.optionsRadio.concat( this.optionsSelect );
    // }
    this.options = this.optionsRadio.concat(this.optionsSelect);
  }
  updateMasterId() {
    // console.log(this.getVariantData());
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }
  handleize(name) {
    return name
      .toLowerCase()
      .replace(/[^\w\u00C0-\u024f]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  customizedVariantSwitch(pdpPwwBlock, circleVariantName, fallbackVariantName) {
    // console.log(circleVariantName);
    if (circleVariantName == undefined || circleVariantName == null) return;

    const words = circleVariantName.split(" ");

    words
      .map((word) => {
        return word[0].toUpperCase() + word.substring(1);
      })
      .join(" ");

    let colorVariantBgClassName = words;
    //console.log("Ayaz : "+colorVariantBgClassName);

    let eachBlock = pdpPwwBlock.querySelectorAll(".pdpfwp_section__js");
    eachBlock.forEach((block) => {
      block.classList.remove("is-oos-product");
      block.querySelector(".oos-info__msg").classList.add("d-none");
      if (block.querySelectorAll(".swatch a").length == 1) return;

      // Check fallback first if metafield exists
      if (fallbackVariantName && fallbackVariantName.trim() !== "") {
        var fallbackVariantNameArr = fallbackVariantName.split(",");
        let fallbackFound = false;

        fallbackVariantNameArr.forEach((variantName) => {
          let variantClassname = "bg-".concat(variantName.replace(" ", ""));

          if (block.querySelector(`.color-variants input[name=${variantName}]`)) {
            block.querySelector(`.color-variants input[name=${variantName}]`).click();
            fallbackFound = true;
          } else if (block.querySelectorAll(`label.${variantClassname}`).length > 0) {
            block.querySelectorAll(`label.${variantClassname}`).forEach((label) => {
              label.click();
            });
            fallbackFound = true;
          }
        });

        if (fallbackFound) {
          if (document.querySelector(".js-bundle-select")) {
            var selected = document.querySelectorAll(".js-bundle-select");
            selected.forEach((sel) => {
              if (sel.classList.contains("active")) sel.click();
            });
          }

          // Handle bundle variants if needed
          if(block.querySelector("bcard-variant .bundle-variants")){
            block
              .querySelector("bcard-variant .bundle-variants")
              ?.querySelectorAll(`label.${fallbackVariantNameArr[0].replace(" ", "")}`)[0]
              ?.click();
          }

          return;
        }
      }

      if (
        block.querySelector(
          `.color-variants input[name=${colorVariantBgClassName}]`
        ) != null
      ) {
        block
          .querySelector(
            `.color-variants input[name=${colorVariantBgClassName}]`
          )
          .click();
        //Added by ayaz
        //console.log("Added by Ayaz");
        if (document.querySelector(".js-bundle-select")) {
          var selected = document.querySelectorAll(".js-bundle-select");
          selected.forEach((sel) => {
            if (sel.classList.contains("active")) sel.click();
          });
        }
      } else {
        if (fallbackVariantName != "") {
          var fallbackVariantNameArr = fallbackVariantName.split(",");
          fallbackVariantNameArr.map((variantName) => {
            let variantClassname = "bg-".concat(variantName.replace(" ", ""));
            if (block.querySelector(`label.${variantClassname}`)) {
              block.querySelector(`label.${variantClassname}`).click();
            }
          });
        } else {
          //console.log("Ayaz check block: "+block.getAttribute("data-isbundle"));
          if (block.getAttribute("data-isbundle") === false) {
            block.classList.add("is-oos-product");
            block.querySelector(".oos-info__msg").classList.remove("d-none");
          }
        }
      }
    });
  }

  updateProductMedia() {
    if (document.querySelector(".pdp_bundle_block")) {
      document.querySelectorAll(".pdp_bundle_block").forEach((pdpPwwBlock) => {
        if (pdpPwwBlock.getAttribute("data-sync") == "true") {
          // console.log("data sync true for bundle");
          let getVariantInfo = document.querySelector(
            `#total-variant__js ul [data-vid="${this.currentVariant.id}"]`
          );
          let fallbackVariantName = getVariantInfo.getAttribute(
            "data-fallbackvariant"
          );
          this.customizedVariantSwitch(
            pdpPwwBlock,
            this.currentVariantOptionLowercase[0],
            fallbackVariantName
          );
        }
      });
    }
  }

  updateMedia() {
    //aayush chanegs

    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    this.currentVariantOptionLowercase = this.currentVariant.options.map(
      (list) => {
        return this.handleize(list.trim().toLowerCase());
      }
    );
    this.currentVariantTitle = this.currentVariantOptionLowercase.join("|");

    const imgLink = this.closest(".card-wrapper").querySelector('a.pdp_pww__image');
    const titleLink = this.closest(".card-wrapper").querySelector('.pdp_bundle__content a');

    if(imgLink){
      let productUrl = imgLink.getAttribute("href").split("?")[0];
      productUrl = productUrl + "?variant=" + this.currentVariant.id;
      imgLink.setAttribute("href", productUrl);
    }
    if(titleLink){
      let titleUrl = titleLink.getAttribute("href").split("?")[0];
      titleUrl = titleUrl + "?variant=" + this.currentVariant.id;
      titleLink.setAttribute("href", titleUrl);
    }

    /** update bg color for product design feature section*/
    var parentElement = this.closest(".thumb-product-card");
    if (parentElement !== null) {
      this.removeClassByPrefix(parentElement, "background-");
      // var addSectionClass =
      //     "background-" +
      //     this.currentVariant.option1.replace(" ", "-").toLowerCase();
      // parentElement.classList.add(addSectionClass);
      // parentElement.querySelector('[name="id"]').value =
      //     this.currentVariant.id;
      const pngImages =
        this.closest(".card-wrapper").querySelectorAll(".card__media img");
      var activeVariant = parentElement.querySelector(
        "bcard-variant .color-variants input:checked"
      ).value;

      if (parentElement.querySelector("bcard-variant .bundle-variants")) {
        const bundleVariant = parentElement.querySelector(
          "bcard-variant .bundle-variants input:checked"
        ).value;
        var activeVariantPrimary = activeVariant + " / " + bundleVariant;
        var activeVariantAlternate = bundleVariant + " / " + activeVariant;
      }
      let breakloop = false;
      // console.log("Nano: "+activeVariantPrimary+'--'+activeVariantAlternate+'--'+activeVariant);
      pngImages.forEach((img) => {
        img.classList.add("d-none");
        //console.log("Ayaz checking color: "+activeVariant+'--'+img.getAttribute('data-variantColor'));

        if (
          activeVariantPrimary == img.getAttribute("data-variantColor") ||
          activeVariantAlternate == img.getAttribute("data-variantColor") ||
          activeVariant == img.getAttribute("data-variantColor")
        ) {
          if(breakloop === false){
            img.classList.remove("d-none");
            breakloop = true;
          }
        }
      });
    } else {
      let imgSrc = this.currentVariant.featured_media.preview_image.src;
      this.closest(".card-wrapper")
        .querySelector(".card__media img")
        .setAttribute("src", imgSrc);
      this.closest(".card-wrapper")
        .querySelector(".card__media img")
        .setAttribute("srcset", "");
      this.closest(".card-wrapper")
        .querySelector(".card__media img")
        .setAttribute("srcset", imgSrc);
    }
  }
  removeClassByPrefix(el, prefix) {
    var regx = new RegExp("\\b" + prefix + ".*?\\b", "g");
    if (el != undefined) {
      el.className = el.className.replace(regx, "");
    }
    return el;
  }
  //&section_id=${this.dataset.section}__main
  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}__main`;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const source = html.getElementById(id);
        let productID;
        if (this.currentVariant.featured_image) {
          productID = this.currentVariant.featured_image.product_id;
        } else {
          productID = this.productId;
        }

        const cardId = `price-card-${productID}`;
        const destination = this.closest(".card-wrapper").querySelector(
          `#${cardId}`
        );

        if (source && destination) {
          destination.innerHTML = source.innerHTML;
        }
        // destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");
      });
  }

  hideVariant(variantObj = null, hideFirst = false) {
    const totalVariant = this.querySelectorAll(".bcard-variants__js li");
    let availableCombinations = new Set();
    let validFirstOptions = new Set();
    let validSecondOptions = new Set();
    let validThirdOptions = new Set();
    let availableVariants = new Map();

    totalVariant.forEach((item) => {
      const title = item.dataset.vtitle;
      const variantHide = item.dataset.vhide === "true";
      const variantStock = item.dataset.vstock === "true";
      const [first, second, third] = title.split("@").map((s) => s.trim());

      if (!variantHide) {
        availableCombinations.add(title);

        // Store variant combination with its stock status
        availableVariants.set(title, {
          first,
          second,
          third,
          inStock: !variantStock,
        });

        // Option handling based on selected options
        if (variantObj && variantObj.option2) {
          if (
            second === variantObj.option2 &&
            (!variantObj.option3 || third === variantObj.option3)
          ) {
            validFirstOptions.add(first);
          }
        }

        if (variantObj && variantObj.option1) {
          if (
            first === variantObj.option1 &&
            (!variantObj.option3 || third === variantObj.option3)
          ) {
            validSecondOptions.add(second);
          }
        }

        if (variantObj && (variantObj.option1 || variantObj.option2)) {
          if (
            (!variantObj.option1 || first === variantObj.option1) &&
            (!variantObj.option2 || second === variantObj.option2)
          ) {
            validThirdOptions.add(third);
          }
        }
      }
      if(!hideFirst) {

        // Handle first-level options visibility
        if (variantObj && (variantObj.option2 || variantObj.option3)) {
          // Handle color swatches
          const colorSwatches = item
            .closest("bcard-variant")
            .querySelectorAll('.color-variants[data-swatch-index="1"] label');

          colorSwatches.forEach((swatch) => {
            const color = swatch.querySelector("span")?.textContent?.trim();
            if (color) {
              if (validFirstOptions.has(color)) {
                swatch.classList.remove("d-none");
                swatch.parentElement.classList.remove("d-none");
              } else {
                swatch.classList.add("d-none");
                swatch.parentElement.classList.add("d-none");
              }
            }
          });

          // Handle color dropdown
          const colorDropdown = item
            .closest("bcard-variant")
            .querySelectorAll('[data-dropdown-index="1"] select option');
          colorDropdown.forEach((option) => {
            const optionValue = option.value.trim();
            if (validFirstOptions.has(optionValue)) {
              option.classList.remove("d-none");
            } else {
              option.classList.add("d-none");
            }
          });

          // Handle kit pills
          const kitPillsFirst = item
            .closest("bcard-variant")
            .querySelectorAll(
              ".bundle-variants[data-kit-index='1'] .form-pill-data"
            );
          kitPillsFirst.forEach((pill) => {
            const value = pill.querySelector("input")?.value?.trim();
            if (value) {
              if (validFirstOptions.has(value)) {
                pill.classList.remove("d-none");
              } else {
                pill.classList.add("d-none");
              }
            }
          });
        }
      }

      // Handle second-level options visibility
      if (variantObj && (variantObj.option1 || variantObj.option3)) {
        // Handle kit pills
        const kitPills = item
          .closest("bcard-variant")
          .querySelectorAll(
            '.bundle-variants[data-kit-index="2"] .form-pill-data'
          );
        kitPills.forEach((pill) => {
          const value = pill.querySelector("input")?.value?.trim();
          if (value) {
            if (validSecondOptions.has(value)) {
              pill.classList.remove("d-none");
            } else {
              pill.classList.add("d-none");
            }
          }
        });

        // Handle dropdown
        const kitDropdown = item
          .closest("bcard-variant")
          .querySelectorAll('[data-dropdown-index="2"] select option');
        kitDropdown.forEach((option) => {
          const optionValue = option.value.trim();
          if (validSecondOptions.has(optionValue)) {
            option.classList.remove("d-none");
          } else {
            option.classList.add("d-none");
          }
        });

        // Handle swatches
        const kitSwatches = item
          .closest("bcard-variant")
          .querySelectorAll('.color-variants[data-swatch-index="2"] label');
        kitSwatches.forEach((swatch) => {
          const swatchLabel = swatch.querySelector("span")?.textContent?.trim();
          if (swatchLabel) {
            if (validSecondOptions.has(swatchLabel)) {
              swatch.classList.remove("d-none");
              swatch.parentElement.classList.remove("d-none");
            } else {
              swatch.classList.add("d-none");
              swatch.parentElement.classList.add("d-none");
            }
          }
        });
      }

      // Handle third-level options visibility
      if (variantObj && (variantObj.option1 || variantObj.option2)) {
        // Handle kit pills
        const kitPills = item
          .closest("bcard-variant")
          .querySelectorAll(
            '.bundle-variants[data-kit-index="3"] .form-pill-data'
          );
        kitPills.forEach((pill) => {
          const value = pill.querySelector("input")?.value?.trim();
          if (value) {
            if (validThirdOptions.has(value)) {
              pill.classList.remove("d-none");
            } else {
              pill.classList.add("d-none");
            }
          }
        });

        // Handle dropdown
        const kitDropdown = item
          .closest("bcard-variant")
          .querySelectorAll('[data-dropdown-index="3"] select option');
        kitDropdown.forEach((option) => {
          const optionValue = option.value.trim();
          if (validThirdOptions.has(optionValue)) {
            option.classList.remove("d-none");
          } else {
            option.classList.add("d-none");
          }
        });

        // Handle swatches
        const kitSwatches = item
          .closest("bcard-variant")
          .querySelectorAll('.color-variants[data-swatch-index="3"] label');
        kitSwatches.forEach((swatch) => {
          const swatchLabel = swatch.querySelector("span")?.textContent?.trim();
          if (swatchLabel) {
            if (validThirdOptions.has(swatchLabel)) {
              swatch.classList.remove("d-none");
              swatch.parentElement.classList.remove("d-none");
            } else {
              swatch.classList.add("d-none");
              swatch.parentElement.classList.add("d-none");
            }
          }
        });
      }

      // Reset visibility when no options are selected
      if (
        !variantObj ||
        (!variantObj.option1 && !variantObj.option2 && !variantObj.option3)
      ) {
        const allOptions = item.closest("bcard-variant").querySelectorAll(`
        .color-variants[data-swatch-index="1"] label,
        [data-dropdown-index="1"] select option,
        .bundle-variants[data-kit-index="1"] .form-pill-data,
        [data-dropdown-index="2"] select option,
        .bundle-variants[data-kit-index="2"] .form-pill-data,
        .color-variants[data-swatch-index="2"] label,
        [data-dropdown-index="3"] select option,
        .bundle-variants[data-kit-index="3"] .form-pill-data,
        .color-variants[data-swatch-index="3"] label
      `);

        totalVariant.forEach((item) => {
          const hide = item.dataset.vhide === "true";
          if (!hide) {
            const [first, second, third] = item.dataset.vtitle
              .split("@")
              .map((s) => s.trim());
            allOptions.forEach((option) => {
              const optionValue =
                option.querySelector("input")?.value ||
                option.value ||
                option.querySelector("span")?.textContent;

              // Check if the option value matches first, second, or third
              if (
                optionValue?.trim() === first ||
                optionValue?.trim() === second ||
                optionValue?.trim() === third
              ) {
                option.classList.remove("d-none");
                option?.parentElement.classList.remove("d-none");
              }
            });
          }
        });
      }

      // Handle sold-out state with flexible variant types
      totalVariant.forEach((item) => {
        const variantStock = item.dataset.vstock === "true";
        const [first, second, third] = item.dataset.vtitle
          .split("@")
          .map((s) => s.trim());

        const handleVariantSoldOut = (level, value) => {
          const variantSelectors = [
            `.color-variants[data-swatch-index="${level}"] .bv-color-swatch-wrapper label`,
            `.bundle-variants[data-kit-index="${level}"] .form-pill-data`,
            `[data-dropdown-index="${level}"] select option`,
          ];

          variantSelectors.forEach((selector) => {
            const elements = item
              .closest("bcard-variant")
              .querySelectorAll(selector);

            elements.forEach((element) => {
              const elementValue =
                element.value?.trim() ||
                element.querySelector("span")?.textContent?.trim() ||
                element.querySelector("input")?.value?.trim();

              if (elementValue === value) {
                // Clear previous states
                element.classList.remove("sold-out");

                // Add sold-out state and disable if out of stock
                if (variantStock) {
                  element.classList.add("sold-out");
                }
              }
            });
          });
        };

        // Apply sold-out states
        if (
          variantObj?.option2 &&
          second === variantObj.option2.trim() &&
          (!variantObj?.option3 || third === variantObj.option3.trim())
        ) {
          handleVariantSoldOut(1, first);
        }

        if (
          variantObj?.option1 &&
          first === variantObj.option1.trim() &&
          (!variantObj?.option3 || third === variantObj.option3.trim())
        ) {
          handleVariantSoldOut(2, second);
        }

        if (
          variantObj?.option1 &&
          first === variantObj.option1.trim() &&
          variantObj?.option2 &&
          second === variantObj.option2.trim()
        ) {
          handleVariantSoldOut(3, third);
        }
      });
    });
  }
  forcedSetActiveInSecondOption(e) {
    let variantStartElm = e.target.closest('bcard-variant');
    let firstActiveJs = variantStartElm?.querySelector('.first_active__js');

    //if there is required to forced to change variant of this option active
    if(firstActiveJs) {
      let closestFieldset = e.target.closest('fieldset');
      if(closestFieldset && closestFieldset.classList.contains('bundle-variants')) {
        let allVariant = firstActiveJs.querySelectorAll('.bv-color-swatch-wrapper');
        let activeVariant = firstActiveJs.querySelectorAll('.bv-color-swatch-wrapper:not(.d-none)');
        if(!this.currentVariant) {
          for(let i = 0; i < allVariant.length; i++) {
            if(!this.currentVariant) {
              allVariant[i].querySelector('label').click();
            }
          }
        } else {
          let hasChecked = false;
          activeVariant.forEach( (act) => {
            if(!act.querySelector("input:checked"))
              hasChecked = true;
          });
          if(hasChecked === false)
            activeVariant[0].querySelector('label').click();
        }
      }
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(
        this.parentNode.querySelector('[type="application/json"]').textContent
      );
    return this.variantData;
  }

  labelClickNew(e) {
    let item = e.target;

    item.click();
    this.addProductToStickyATC();
    this.updateAdOnsItems();

    this.optionsSelect = this.optionsRadio = [];
    if (this.querySelector("fieldset")) {
      const fieldsets = this.querySelectorAll("fieldset");
      let selectedVariant = '';
      fieldsets.forEach ( (inp) => {
        let chk='';
        if(inp.querySelector('input:checked'))
          chk = inp.querySelector('input:checked').value;
        selectedVariant = selectedVariant + chk + ' / ';
      });
      const variantStr = selectedVariant.trim().replace(/\/+$/, '').trim();
      let updateTotal = false;
      let selectedBundleTypes = null;

      selectedBundleTypes = document.querySelectorAll(".js-bundle-items, .js-adons-items, .bundle-mirror .bundle-items");
      if(selectedBundleTypes){
        selectedBundleTypes.forEach( (itemb) => {
          const pcalc = itemb.classList.contains('pCalc');
          if(pcalc === true)
            updateTotal = true;
          else
            updateTotal = false;
          let selectedBundleItems = null;
          if(itemb)
            selectedBundleItems = itemb.querySelector("img[data-variantcolor='"+variantStr+"'");
          if(selectedBundleItems){
            const selectedVariantRegularPrice = selectedBundleItems.getAttribute("data-regularprice");
            const selectedVariantSalesPrice = selectedBundleItems.getAttribute("data-saleprice");
            const selectedVariantHandle = selectedBundleItems.getAttribute("data-product-handle");
            const selectedItem = itemb.querySelector("[data-url='"+selectedVariantHandle+"'");
            const updatePrice = selectedItem.querySelector("[data-id='product-pdp_bundle'");

            this.pdpPwwPriceUpdate(updatePrice, 'minus', updateTotal);

            updatePrice.setAttribute("data-regularprice", selectedVariantRegularPrice);
            updatePrice.setAttribute("data-saleprice", selectedVariantSalesPrice);

            //for changing price in display section
            const parentElement = updatePrice.parentElement;
            const previousSibling = parentElement.previousElementSibling;

            const pdpPriceElm = previousSibling.querySelector('.price__js .price');
            const pdpRegulaPrice = pdpPriceElm
                .querySelector(".price__sale .price-item--regular");
            const pdpSalesPrice = pdpPriceElm
                .querySelector(".price__sale .price-item--sale");
            pdpRegulaPrice.innerHTML = `+ $${selectedVariantRegularPrice}`;
            pdpSalesPrice.innerHTML = `+ $${selectedVariantSalesPrice}`;

            this.pdpPwwPriceUpdate(updatePrice, 'plus', updateTotal);
          }
        });
      }

      this.updateClonePrice();
      this.updateSavingAmount();
      if (document.querySelector(".sticky-atc")) {
        this.updateStickyATCInfo();
      }

    }
  }

  updateAdOnsItems = () => {
    if(document.querySelector('.pdp_pww_block')){
      let pdpAdOnsitems = document.querySelectorAll('.pdp_pww_block [data-id="product-pdp_pww"].checked');
      pdpAdOnsitems.forEach( (adons) => {
        adons.click();
      });
    }
  }

  updateSavingAmount() {
    var totalPriceSection = document.querySelector(".pdpPww-total-price__js");
    var totalRegPrice = parseFloat(totalPriceSection.querySelector(
      ".price__sale .price-item--regular"
    ).innerHTML.replace("$", ""));
    var totalSalePrice = parseFloat(totalPriceSection.querySelector(
      ".price__sale .price-item--sale"
    ).innerHTML.replace("$", ""));
    let priceSaved = document.querySelectorAll(".price-saved-badge-wrapper .price-saved-badge");

    if(totalSalePrice < totalRegPrice){
      let calculatedSaving = (parseFloat(totalRegPrice) - parseFloat(totalSalePrice))
                                .toFixed(2)
                                .replace(/\.00$/, "");
      let priceSaveBadge = "$"+calculatedSaving+" Savings";

      priceSaved.forEach( (savedPrice) => {
        if(savedPrice.classList.contains('d-none'))
          savedPrice.classList.remove('d-none');
        savedPrice.innerHTML = priceSaveBadge;
      });
    }
    else{
      priceSaved.forEach( (savedPrice) => {
        if(!savedPrice.classList.contains('d-none'))
          savedPrice.classList.add('d-none');
        savedPrice.innerHTML = "";
      });
    }
  }

  pdpPwwPriceUpdate = (e, type, updateTotal) => {
    var itemRegularPrice, itemSalePrice;
    //var actualEvent = e;
    itemRegularPrice = e.getAttribute("data-regularprice");
    itemSalePrice = e.getAttribute("data-saleprice");

    const productPrice = document.querySelector(".main-bundle-product [data-id='product-pdp_bundle']");
    let totalPriceSection = document.querySelector(".pdpPww-total-price__js");
    let pdpPriceElm = totalPriceSection.querySelector(".renderPrice .price");

    //this.updatePDP
    if (totalPriceSection != null) {
      if (itemRegularPrice != itemSalePrice) {
        if (itemRegularPrice == 0) {
          itemRegularPrice = itemSalePrice;
        }
        pdpPriceElm.classList.add("price--on-sale");
      }


      if (pdpPriceElm.classList.contains("price--on-sale")) {
        var currentRegSec = totalPriceSection.querySelector(
          ".price__sale .price-item--regular"
        );
        var currentSaleSec = totalPriceSection.querySelector(
          ".price__sale .price-item--sale"
        );
        var currentRegSecOnce = totalPriceSection.querySelector(
          ".price__regular .price-item--regular"
        );
      } else {
        var currentRegSec = totalPriceSection.querySelector(
          ".price__sale .price-item--regular"
        );
        var currentSaleSec = totalPriceSection.querySelector(
          ".price__sale .price-item--sale"
        );
        var currentRegSecOnce = totalPriceSection.querySelector(
          ".price__regular .price-item--regular"
        );
      }
      var currentRegPrice = productPrice.getAttribute("data-regularPrice");
      var currentSalePrice = productPrice.getAttribute("data-salePrice");

      if (type == "plus") {
        //this.gtmPush(actualEvent);
        var totalRegPrice = (
          parseFloat(currentRegPrice) + parseFloat(itemRegularPrice)
        )
          .toFixed(2)
          .replace(/\.00$/, "");
        var totalSalePrice = (
          parseFloat(currentSalePrice) + parseFloat(itemSalePrice)
        )
          .toFixed(2)
          .replace(/\.00$/, "");
      }
      if (type == "minus") {
        var totalRegPrice = (
          parseFloat(currentRegPrice) - parseFloat(itemRegularPrice)
        )
          .toFixed(2)
          .replace(/\.00$/, "");
        var totalSalePrice = (
          parseFloat(currentSalePrice) - parseFloat(itemSalePrice)
        )
          .toFixed(2)
          .replace(/\.00$/, "");
      }
      if(updateTotal === true){
        currentRegSec.innerHTML = `$${totalRegPrice}`;
        currentSaleSec.innerHTML = `$${totalSalePrice}`;

        productPrice.setAttribute("data-regularPrice", totalRegPrice);
        productPrice.setAttribute("data-salePrice", totalSalePrice);

        if (currentRegSecOnce) {
          currentRegSecOnce.innerHTML = `$${totalRegPrice}`;
        }
      }

      if (productPrice.getAttribute("data-regularprice") === productPrice.getAttribute("data-saleprice")) {
        totalPriceSection
          .querySelector(".renderPrice .price")
          .classList.remove("price--on-sale");
      }
    }
  };

  updateStickyATCInfo = () => {
    /**For price section*/
    let stickyBottomTotalPrice = document.getElementById(
      "stickyBottomTotalPrice"
    );
    let pdpPwwtotalPrice = document.querySelector(".pdpPww-total-price__js");
    if (stickyBottomTotalPrice != null && pdpPwwtotalPrice != null) {
      let pdpTotalPrice = pdpPwwtotalPrice.innerHTML;
      stickyBottomTotalPrice.innerHTML = pdpTotalPrice;
    }
    /**For color section*/
    // let productSelectedColorVariant = document.querySelector('variant-starts .color-swatch-variant .selected').innerHTML;
    // document.querySelector('.sticky-atc .color-swatch-variant').innerHTML = productSelectedColorVariant;

    let productSelectedColorVariantLabel = document.querySelector(
      "variant-starts .color-swatch-variant .color-swatch-main-product input:checked ~ label"
    );
    let colorSwatchLabel = document.querySelector(
      ".sticky-atc .color-swatch-variant label"
    );
    if (colorSwatchLabel) {
      if (productSelectedColorVariantLabel) {
        let clonedVariantLabel =
          productSelectedColorVariantLabel.cloneNode(true);
        colorSwatchLabel.replaceWith(clonedVariantLabel);
      } else {
        colorSwatchLabel.classList.add("d-none");
      }
    }

    let colorSwatch = document.querySelector(
      ".sticky-atc .color-swatch-variant > span"
    );
    let productSelectedColorVariant = document.querySelector(
      "variant-starts .color-swatch-variant .selected"
    );
    let productSelectedDropdownVariantLabel = document.querySelector(
      "variant-starts .js-mainProductDropdownVariant select"
    );

    if (productSelectedColorVariant) {
      colorSwatch.innerHTML = productSelectedColorVariant.innerHTML;
    } else if (productSelectedDropdownVariantLabel) {
      colorSwatch.innerHTML = productSelectedDropdownVariantLabel.value;
    }
  };

  updateClonePrice = () => {
    let pdpPwwtotalPriceCloneSection = document.querySelectorAll(
      ".pdpPww-total-price-clone__js"
    );

    if (pdpPwwtotalPriceCloneSection.length > 0) {
      pdpPwwtotalPriceCloneSection.forEach((pdpPwwtotalPriceClone) => {
        let pdpPwwtotalPrice = document.querySelector(
          ".pdpPww-total-price__js"
        );

        if (pdpPwwtotalPriceClone && pdpPwwtotalPrice != null) {
          pdpPwwtotalPriceClone.innerHTML = pdpPwwtotalPrice.innerHTML;
        }
        pdpPwwtotalPriceClone.querySelector("span.your-total-text").textContent = "Bundle Total:";
      });
    }
  };

}
customElements.define("bcard-variant", BCardVariant);

//Metaobjects bundles created in pdp page
class PDPBundles extends HTMLElement {
  constructor() {
    super();
    this.mainProduct();
    this.querySelectorAll('.js-bundle-select').forEach((bundleImage)=>{
      bundleImage.addEventListener("click", this.addBundleItems);
    });

    const mainVariantSection = document.querySelector("variant-starts");
    if (mainVariantSection) {
      // Use arrow function to preserve 'this' context
      mainVariantSection.addEventListener("change", () => {
        const isCustom = this.isCustomized() === true;

        if (isCustom) {
          this.cartEntryForCustomizedBundle();
          this.updateCustomizationClass();
        }
      });
    }
  }

  mainProduct = () => {
    var mainProduct = document.querySelector(".js-main-product");
    const mItem = mainProduct.querySelectorAll(".pdp_bundle .variant-color");
  }

  gtmTracking(e = null , type = null) {
    if( e == null )
      return false;
    let itemTitle = "bundleName";
    let eventName = "Clicked - PDP Bundle";
    let currentVariantTitle = "No bundle name Found";
    if(type == "add" || type == "remove"){
      if(type=="add")
        eventName = "Clicked - Added item to bundle";
      if(type=="remove")
        eventName = "Clicked - Removed item from bundle";
      itemTitle = "itemName";
      var actualEvent = e.target;
      currentVariantTitle = actualEvent.getAttribute("data-product-title");
    }
    else{
      var actualEvent = e.target;
      if(!e.target.classList.contains("js-bundle-select"))
          actualEvent = e.target.parentNode.parentNode;
      currentVariantTitle = actualEvent.getAttribute("data-bundle-name");
  }

    window.dataLayer.push({
      event: eventName
          ? eventName
          : "Clicked - PDP Bundle",
        itemTitle: currentVariantTitle
            ? currentVariantTitle
            : "No bundle name Found",
      // itemsAdded: "Item 1 added",
      // itemsremoved: "Item 2 removed",
      pagePath: window.location.pathname,
      pageTitle: document.title,
    });
  }

  updateSavingAmount() {
    var totalPriceSection = document.querySelector(".pdpPww-total-price__js");
    var totalRegPrice = parseFloat(totalPriceSection.querySelector(
      ".price__sale .price-item--regular"
    ).innerHTML.replace("$", ""));
    var totalSalePrice = parseFloat(totalPriceSection.querySelector(
      ".price__sale .price-item--sale"
    ).innerHTML.replace("$", ""));
    let priceSaved = document.querySelectorAll(".price-saved-badge-wrapper .price-saved-badge");

    if(totalSalePrice < totalRegPrice){
      let calculatedSaving = (parseFloat(totalRegPrice) - parseFloat(totalSalePrice))
                                .toFixed(2)
                                .replace(/\.00$/, "");
      let priceSaveBadge = "$"+calculatedSaving+" Savings";

      priceSaved.forEach( (savedPrice) => {
        if(savedPrice.classList.contains('d-none'))
          savedPrice.classList.remove('d-none');
        savedPrice.innerHTML = priceSaveBadge;
      });
    }
    else{
      priceSaved.forEach( (savedPrice) => {
        if(!savedPrice.classList.contains('d-none'))
          savedPrice.classList.add('d-none');
        savedPrice.innerHTML = "";
      });
    }
  }

  addBundleItems = (e) => {
    const buns = document.querySelectorAll(".js-bundle-select");
    //remove active class
    buns.forEach((b) => {
      b.classList.remove("active");
    });

    const selectedBundleName =
      e.currentTarget.getAttribute("data-bundle-name");

    //GTM Call
    this.gtmTracking(e);

    document.getElementById("isAlreadyTriggered").value = "true";
    document
    .querySelector("input[value='" + selectedBundleName + "']")
    .click();

    var selectedItems = document.getElementById("js_bundle_items");
    var bundleList = selectedItems.querySelector(".js-bundle-items");

    // Access the child element inside the clicked parent
    const bundleItems = e.currentTarget.getAttribute(
      "data-bundle-container"
    );
    const productItems = document.querySelector(
      "." + bundleItems + " .bundle-items"
    );
    const removeButton = bundleList.querySelectorAll(".remove-button");
    e.currentTarget.classList.add("active");

    if (productItems) {
      if (
        !selectedItems
          .querySelector(".no-selection")
          .classList.contains("d-none")
      )
        selectedItems
          .querySelector(".no-selection")
          .classList.add("d-none");

      const PICopy = productItems.cloneNode(true);
      var iCount = Math.floor(Math.random() * 2);

      // change the name of the radio and lable
      const originalRadios = productItems.querySelectorAll(
        'input[type="radio"]'
      );

      //change the ids of all the color radios
      const clonedRadios = PICopy.querySelectorAll('input[type="radio"]');
      clonedRadios.forEach((radio, index) => {
        const currentId = radio.id;
        const newId = `${currentId}-${iCount}`;
        radio.id = newId;
        radio.name = radio.name + "-" + iCount;
        if (originalRadios[index]?.checked) {
          radio.setAttribute("checked", "checked");
        }
        const label = PICopy.querySelector(`label[for="${currentId}"]`);

        if (label) {
          label.setAttribute("for", newId);
        }
      });

      const productPrice = document.querySelector(".main-bundle-product [data-id='product-pdp_bundle']");
      const regularPrice = productPrice.getAttribute("data-regularoriginal");
      const salePrice = productPrice.getAttribute("data-saleoriginal");
      productPrice.setAttribute("data-regularprice", regularPrice);
      productPrice.setAttribute("data-saleprice", salePrice);

      let extraPrice = document.getElementById("product-extra-prices");
      extraPrice.innerHTML="";
      bundleList.innerHTML = PICopy.innerHTML;

      bundleList.querySelectorAll(".pdpfwp_section__js").forEach((item) => {
        this.updateAddtoCartList(item);
      });
      this.addProductToStickyATC();
    }

    this.updateCustomizedItems();

    const cartTargetDiv = document.getElementById("product-extra-prices");
    if (
      cartTargetDiv &&
      cartTargetDiv.previousElementSibling?.name === "id"
    ) {
      this.cartEntryForCustomizedBundle();
      this.updateCustomizationClass();
    }

  };

  cartEntryForCustomizedBundle() {
    let firstVariant = document.querySelector(
      "input[name='Color']:checked"
    ).value;
    let bundleVariant = document.querySelectorAll("input[name='Bundles']");
    let secondVariant = "";
    if (bundleVariant.length > 0) {
      secondVariant = bundleVariant[0].value; // Get the value of the first radio button
    }
    let variantName = firstVariant + " / " + secondVariant;
    let variantIdSelector = document.querySelector(
      "#total-variant__js li[data-vtitle='" + variantName + "']"
    );
    let variantId = variantIdSelector.getAttribute("data-vid");

    const targetDiv = document.getElementById("product-extra-prices");
    if (targetDiv && targetDiv.previousElementSibling?.name === "id") {
      targetDiv.previousElementSibling.value = variantId;
    }
  }

  addProductToStickyATC = () => {
    let atcHolder = document.querySelector("#selectedBundleItems");
    if (!atcHolder) return;
    let selecteditems = document.querySelectorAll(".js_all_products .pdp_bundle");
    atcHolder.innerHTML = '';
    var imageCount = 0;

    selecteditems.forEach((item) => {
      let selectedItemImage = item.querySelectorAll("img");
      let selectedImage = '';
      let variantID = '';
      selectedItemImage.forEach((imgs, index) => {
        if ( imgs.classList.contains("show") || !imgs.classList.contains("d-none")){
          imgs.className='';
          variantID = imgs.getAttribute("data-variant-id");
          selectedImage = imgs.cloneNode(true);
        }
      });
      if (selectedImage && atcHolder && variantID) {
        if (imageCount < 4) {
          const wrapper = document.createElement("div");
          wrapper.className = "sticky-atc-img";
          wrapper.setAttribute("data-variant-id", variantID);
          wrapper.appendChild(selectedImage);
          atcHolder.appendChild(wrapper);
        }
        imageCount++;
      }
    });
    if(imageCount > 3){
      const moreButton = document.createElement("a");
      moreButton.setAttribute("tabindex", "0");
      moreButton.setAttribute("role", "button");
      moreButton.className = "more-button";
      moreButton.setAttribute("aria-label", "Click to View Bundle");
      moreButton.innerHTML = "+" + (imageCount - 4);
      atcHolder.appendChild(moreButton);
    }
  }

  updateAddtoCartList = (pitem) => {
    const itemValues = pitem.querySelector(
      '.checked[data-id="product-pdp_bundle"]'
    );
    var itemVariantID = "";
    const varitantImages = pitem.querySelectorAll(
      ".thumb-product-card-images img"
    );
    varitantImages.forEach((imgs) => {
      if (imgs.classList.contains("show") || !imgs.classList.contains("d-none"))
        itemVariantID = imgs.getAttribute("data-variant-id");
    });
    this.createInputData(
      itemValues.getAttribute("data-index"),
      itemVariantID,
      null
    );
    this.pdpPwwPriceUpdate(itemValues, "plus");

    this.updateClonePrice();
    this.updateSavingAmount();
    if (document.querySelector(".sticky-atc")) {
      this.updateStickyATCInfo();
    }
    //});
  };

  updateCustomizedItems = (handle = "", display = false) => {
    const customizeAdons = document.querySelector(".js-adons-items");
    const adonItems = customizeAdons.querySelectorAll(".pdp_bundle");
    adonItems.forEach((adon) => {
      adon.classList.remove("js-bundle-items--transition");
      adon.classList.remove("d-none");
    });
    if (handle) {
      adonItems.forEach((adon) => {
        const adonItem = adon.getAttribute("data-url");
        if (handle == adonItem && display === false) {
          adon.classList.remove("js-bundle-items--full");
          adon.classList.add("js-bundle-items--transition");
          adon.classList.add("d-none");
        }

        if (handle == adonItem && display === true) {
          adon.classList.remove("js-bundle-items--full");
          adon.classList.remove("d-none");
          adon.classList.remove("js-bundle-items--transition");
        }
      });
    } else {
      const bundles = document.querySelector(".js-bundle-items");
      const bundleItems = bundles.querySelectorAll(".pdp_bundle");
      bundleItems.forEach((item) => {
        const itemHandleInBundle = item.getAttribute("data-url");

        adonItems.forEach((adon) => {
          const adonItem = adon.getAttribute("data-url");
          if (itemHandleInBundle == adonItem) {
            adon.classList.add("js-bundle-items--transition");
            adon.classList.add("d-none");
          }
        });
      });
    }
    var itemCount = 0;
    if (adonItems.length > 0) {
      adonItems.forEach((ait) => {
        if (!ait.classList.contains("d-none")) itemCount = itemCount + 1;
      });
    }

    if (itemCount == 0)
      document.querySelector(".customizer")?.classList.add("d-none");
    else document.querySelector(".customizer")?.classList.remove("d-none");
  };

  removeBundleItems = (bundle) => {
    if (bundle) {
      const removeButton = bundle.querySelectorAll(
        ".js-bundle-items .remove-button"
      );
      removeButton.forEach((eBut) => {
        eBut.addEventListener("click", (event) => {
          event.stopPropagation();
          const selectedItems = document.getElementById("js_bundle_items");
          const removeItem = eBut.getAttribute("data-product");
          const divToRemove = document.querySelector(
            ".js-bundle-items ." + removeItem
          );
          const itemValues = divToRemove.querySelector(
            '.checked[data-id="product-pdp_bundle"]'
          );

          //GTM code
          // this.gtmTracking(event, "remove");

          this.removeInputData(itemValues.getAttribute("data-index"));

          this.pdpPwwPriceUpdate(itemValues, "minus");
          this.updateClonePrice();
          if (document.querySelector(".sticky-atc")) {
            this.updateStickyATCInfo();
          }
          if (divToRemove) {
            divToRemove.classList.add("js-bundle-items--transition");
            divToRemove.classList.remove("js-bundle-items--full");
            this.updateSavingAmount();
            // setTimeout(() => {
              divToRemove.classList.add("d-none");
            // }, 0);
            // setTimeout(() => {
              divToRemove.remove();
              this.updateCustomizationClass();
              this.addProductToStickyATC();
            // }, 0);
          }

          //console.log("Ayaz 20 Dec:"+ removeItem)
          this.updateCustomizedItems(removeItem.replace("prod-", ""), true);

          //if no item in the list show  no-selection class
          if (
            selectedItems.querySelector(".js-bundle-items").innerHTML.trim() ===
            ""
          ) {
            selectedItems
              .querySelector(".no-selection")
              .classList.remove("d-none");
          }
        });
      });
    }
  };

  setupCustomizationObserver() {
    this.updateCustomizationClass();
    const bundleInputs = document.querySelectorAll("input[name='Bundles']");
    bundleInputs.forEach((input) => {
      input.addEventListener("change", () => {
        this.updateCustomizationClass();
      });
    });
  }

  updateCustomizationClass() {
    if (this.isCustomized()) {
      this.classList.add("is-customized");
    } else {
      this.classList.remove("is-customized");
    }
  }

  isCustomized = () => {
    let bundleVariant = document.querySelectorAll("input[name='Bundles']");
    let selectedBundle = "";

    bundleVariant.forEach((bvariant) => {
        if (bvariant.checked || bvariant.hasAttribute("checked")) {
            selectedBundle = bvariant.value;
        }
    });

    if (!selectedBundle) return false;

    let yourSelectedBundle = document.querySelectorAll(".js-bundle-items .pdp_bundle");
    if(yourSelectedBundle.length<1)
      return false;

    let mirrorBundle = document.querySelector("[data-mirror-bundle='" + selectedBundle + "']");
    if (!mirrorBundle) return false;

    let mbItems = mirrorBundle.querySelectorAll(".bundle-items .pdp_bundle");


    if (mbItems.length != yourSelectedBundle.length) {
        return true;
    }

    let similarItemCount = 0;

    mbItems.forEach((pdpItem) => {
        let bundleItemName = pdpItem.getAttribute("data-url");

        yourSelectedBundle.forEach((ysb) => {
            if (ysb.getAttribute("data-url") == bundleItemName) {
                similarItemCount += 1;
            }
        });
    });

    if (similarItemCount != yourSelectedBundle.length) {
        return true;
    }

    return false;
  };

  pdpPwwPriceUpdate = (e, type) => {
    var itemRegularPrice, itemSalePrice;

    itemRegularPrice = e.getAttribute("data-regularprice");
    itemSalePrice = e.getAttribute("data-saleprice");

    const productPrice = document.querySelector(".main-bundle-product [data-id='product-pdp_bundle']");
    let totalPriceSection = document.querySelector(".pdpPww-total-price__js");
    let pdpPriceElm = totalPriceSection.querySelector(".renderPrice .price");

    if (totalPriceSection != null) {
      if (itemRegularPrice != itemSalePrice) {
        if (itemRegularPrice == 0) {
          itemRegularPrice = itemSalePrice;
        }
        pdpPriceElm.classList.add("price--on-sale");
      }

      if (pdpPriceElm.classList.contains("price--on-sale")) {
        var currentRegSec = totalPriceSection.querySelector(
          ".price__sale .price-item--regular"
        );
        var currentSaleSec = totalPriceSection.querySelector(
          ".price__sale .price-item--sale"
        );
        var currentRegSecOnce = totalPriceSection.querySelector(
          ".price__regular .price-item--regular"
        );
      } else {
        var currentRegSec = totalPriceSection.querySelector(
          ".price__sale .price-item--regular"
        );
        var currentSaleSec = totalPriceSection.querySelector(
          ".price__sale .price-item--sale"
        );
        var currentRegSecOnce = totalPriceSection.querySelector(
          ".price__regular .price-item--regular"
        );
      }
      var currentRegPrice = productPrice.getAttribute("data-regularprice");
      var currentSalePrice = productPrice.getAttribute("data-saleprice");

      if (type == "plus") {
        var totalRegPrice = (
          parseFloat(currentRegPrice) + parseFloat(itemRegularPrice)
        )
          .toFixed(2)
          .replace(/\.00$/, "");
        var totalSalePrice = (
          parseFloat(currentSalePrice) + parseFloat(itemSalePrice)
        )
          .toFixed(2)
          .replace(/\.00$/, "");
      }
      if (type == "minus") {
        var totalRegPrice = (
          parseFloat(currentRegPrice) - parseFloat(itemRegularPrice)
        )
          .toFixed(2)
          .replace(/\.00$/, "");
        var totalSalePrice = (
          parseFloat(currentSalePrice) - parseFloat(itemSalePrice)
        )
          .toFixed(2)
          .replace(/\.00$/, "");
      }
      currentRegSec.innerHTML = `$${totalRegPrice}`;
      currentSaleSec.innerHTML = `$${totalSalePrice}`;
      productPrice.setAttribute("data-regularPrice", totalRegPrice);
      productPrice.setAttribute("data-salePrice", totalSalePrice);


      if (productPrice.getAttribute("data-regularprice") === productPrice.getAttribute("data-saleprice")) {
        totalPriceSection
          .querySelector(".renderPrice .price")
          .classList.remove("price--on-sale");
      }

      if (currentRegSecOnce) {
        currentRegSecOnce.innerHTML = `$${totalRegPrice}`;
      }
    }
  };

  updateStickyATCInfo = () => {
    /**For price section*/
    let stickyBottomTotalPrice = document.getElementById(
      "stickyBottomTotalPrice"
    );
    let pdpPwwtotalPrice = document.querySelector(".pdpPww-total-price__js");
    if (stickyBottomTotalPrice != null && pdpPwwtotalPrice != null) {
      let pdpTotalPrice = pdpPwwtotalPrice.innerHTML;
      stickyBottomTotalPrice.innerHTML = pdpTotalPrice;
    }
    /**For color section*/
    // let productSelectedColorVariant = document.querySelector('variant-starts .color-swatch-variant .selected').innerHTML;
    // document.querySelector('.sticky-atc .color-swatch-variant').innerHTML = productSelectedColorVariant;

    let productSelectedColorVariantLabel = document.querySelector(
      "variant-starts .color-swatch-variant .color-swatch-main-product input:checked ~ label"
    );
    let colorSwatchLabel = document.querySelector(
      ".sticky-atc .color-swatch-variant label"
    );
    if (colorSwatchLabel) {
      if (productSelectedColorVariantLabel) {
        let clonedVariantLabel =
          productSelectedColorVariantLabel.cloneNode(true);
        colorSwatchLabel.replaceWith(clonedVariantLabel);
      } else {
        colorSwatchLabel.classList.add("d-none");
      }
    }

    let colorSwatch = document.querySelector(
      ".sticky-atc .color-swatch-variant > span"
    );
    let productSelectedColorVariant = document.querySelector(
      "variant-starts .color-swatch-variant .selected"
    );
    let productSelectedDropdownVariantLabel = document.querySelector(
      "variant-starts .js-mainProductDropdownVariant select"
    );

    if (productSelectedColorVariant) {
      colorSwatch.innerHTML = productSelectedColorVariant.innerHTML;
    } else if (productSelectedDropdownVariantLabel) {
      colorSwatch.innerHTML = productSelectedDropdownVariantLabel.value;
    }
  };

  updateClonePrice = () => {
    let pdpPwwtotalPriceCloneSection = document.querySelectorAll(
      ".pdpPww-total-price-clone__js"
    );

    if (pdpPwwtotalPriceCloneSection.length > 0) {
      pdpPwwtotalPriceCloneSection.forEach((pdpPwwtotalPriceClone) => {
        let pdpPwwtotalPrice = document.querySelector(
          ".pdpPww-total-price__js"
        );

        if (pdpPwwtotalPriceClone && pdpPwwtotalPrice != null) {
          pdpPwwtotalPriceClone.innerHTML = pdpPwwtotalPrice.innerHTML;
        }
        pdpPwwtotalPriceClone.querySelector("span.your-total-text").textContent = "Bundle Total:";
      });
    }
  };

  //To add to the list of add to cart form
  createInputData(num, value, qty) {
    let extraPrice = document.getElementById("product-extra-prices");
    let fieldAlreadyAdded = extraPrice.querySelector(
      `[name="items[${num}]id"]`
    );
    let fieldQty = extraPrice.querySelector(`[name="items[${num}]quantity"]`);
    if (!fieldAlreadyAdded) {
      var x = document.createElement("INPUT");
      x.setAttribute("type", "hidden");
      x.setAttribute("name", `items[${num}]id`);
      x.setAttribute("value", value);
      // return x;
      extraPrice.appendChild(x);
    }
    if (!fieldQty && qty != null) {
      var x = document.createElement("INPUT");
      x.setAttribute("type", "hidden");
      x.setAttribute("name", `items[${num}]quantity`);
      x.setAttribute("value", qty);
      extraPrice.appendChild(x);
    }
  }

  removeInputData(num) {
    let extraPrice = document.getElementById("product-extra-prices");
    let fieldAlreadyAdded = extraPrice.querySelector(
      `[name="items[${num}]id"]`
    );
    if (fieldAlreadyAdded) fieldAlreadyAdded.remove();
  }
}
customElements.define("bundled-product", PDPBundles);


class ActionButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onActionChange);
  }

  onActionChange (e) {
    if(e.target.classList.contains('remove-button'))
      this.removeBundleItems(e);
    else
      this.addOnsItems(e);
  }

  addOnsItems (e) {
    const item = e.target;
    let addons = document.querySelector(".js-adons-items");

    const itemHandle = item
        .getAttribute("data-product")
        .replace("prod-", "");
    const itemData = addons.querySelector(
      "[data-url='" + itemHandle + "']"
    );
    const copyItemData = itemData.cloneNode(true);
    var iCount = Math.floor(Math.random() * 2);

    const originalRadios = itemData.querySelectorAll("input[type='radio']");

    //change new id for each radio buttons
    var clonedRadios = copyItemData.querySelectorAll("input[type='radio']");
    clonedRadios.forEach((radio, index) => {
      const currentId = radio.id;
      const newId = `${currentId}-${iCount}`;
      radio.id = newId;
      radio.name = radio.name + "-" + iCount;
      if (originalRadios[index]?.checked) {
        radio.setAttribute("checked", "checked");
      }
      const label = copyItemData.querySelector(`label[for="${currentId}"]`);

      if (label) {
        label.setAttribute("for", newId);
      }
    });

    const bundleList = document.querySelector(".js-bundle-items");
    const addButton = copyItemData.querySelector(".add-button");
    const itemWithVariant = document.querySelectorAll(".itemWithVariant");
    const itemValues = copyItemData.querySelector(
      '.checked[data-id="product-pdp_bundle"]'
    );
    let showVariant = false;

    itemWithVariant.forEach((vitem) => {
      if (vitem.value == itemHandle) showVariant = true;
    });

    copyItemData.querySelector(".price__sale").classList.add("d-none");

    if (showVariant == true)
      copyItemData
        .querySelector(".variant-color")
        .classList.remove("d-none");

    addButton.classList.remove("add-button");
    addButton.classList.add("remove-button");
    addButton.innerHTML = "Remove";
    copyItemData.classList.add("js-bundle-items--transition");
    bundleList.appendChild(copyItemData);

    //GTM code
    this.gtmTracking(e, "add");

    copyItemData.classList.add("js-bundle-items--full");

    this.updateCustomizationClass();
    this.updateAddtoCartList(copyItemData);
    this.addProductToStickyATC();
    this.updateCustomizedItems(itemHandle);
  };

  removeBundleItems (e) {
    const eBut = e.target;
    const selectedItems = document.getElementById("js_bundle_items");
    const removeItem = eBut.getAttribute("data-product");
    const divToRemove = document.querySelector(
      ".js-bundle-items ." + removeItem
    );
    const itemValues = divToRemove.querySelector(
      '.checked[data-id="product-pdp_bundle"]'
    );

    //GTM code
    this.gtmTracking(e, "remove");

    this.removeInputData(itemValues.getAttribute("data-index"));

    this.updateAdOnsItems();

    this.pdpPwwPriceUpdate(itemValues, "minus");
    this.updateClonePrice();
    if (document.querySelector(".sticky-atc")) {
      this.updateStickyATCInfo();
    }
    if (divToRemove) {
      divToRemove.classList.add("js-bundle-items--transition");
      divToRemove.classList.remove("js-bundle-items--full");
      this.updateSavingAmount();
      divToRemove.classList.add("d-none");
      divToRemove.remove();
      this.addProductToStickyATC();
    }

    this.updateCustomizedItems(removeItem.replace("prod-", ""), true);
    this.updateCustomizationClass();
    //if no item in the list show  no-selection class
    if (
      selectedItems.querySelector(".js-bundle-items").innerHTML.trim() ===
      ""
      ) {
      selectedItems
        .querySelector(".no-selection")
        .classList.remove("d-none");
    }
  }

  updateAdOnsItems = () => {
    if(document.querySelector('.pdp_pww_block')){
      let pdpAdOnsitems = document.querySelectorAll('.pdp_pww_block [data-id="product-pdp_pww"].checked');
      pdpAdOnsitems.forEach( (adons) => {
        adons.click();
      });
    }
  }

  pdpPwwPriceUpdate = (e, type) => {
    var itemRegularPrice, itemSalePrice;
    itemRegularPrice = e.getAttribute("data-regularprice");
    itemSalePrice = e.getAttribute("data-saleprice");
    const productPrice = document.querySelector(".main-bundle-product [data-id='product-pdp_bundle']");
    let totalPriceSection = document.querySelector(".pdpPww-total-price__js");
    let pdpPriceElm = totalPriceSection.querySelector(".renderPrice .price");

    //this.updatePDP
    if (totalPriceSection != null) {
      if (itemRegularPrice != itemSalePrice) {
        if (itemRegularPrice == 0) {
          itemRegularPrice = itemSalePrice;
        }
        pdpPriceElm.classList.add("price--on-sale");
      }

      if (pdpPriceElm.classList.contains("price--on-sale")) {
        var currentRegSec = totalPriceSection.querySelector(
          ".price__sale .price-item--regular"
        );
        var currentSaleSec = totalPriceSection.querySelector(
          ".price__sale .price-item--sale"
        );
        var currentRegSecOnce = totalPriceSection.querySelector(
          ".price__regular .price-item--regular"
        );
      } else {
        var currentRegSec = totalPriceSection.querySelector(
          ".price__sale .price-item--regular"
        );
        var currentSaleSec = totalPriceSection.querySelector(
          ".price__sale .price-item--sale"
        );
        var currentRegSecOnce = totalPriceSection.querySelector(
          ".price__regular .price-item--regular"
        );
      }
      var currentRegPrice = productPrice.getAttribute("data-regularPrice");
      var currentSalePrice = productPrice.getAttribute("data-salePrice");

      if (type == "plus") {
        var totalRegPrice = (
          parseFloat(currentRegPrice) + parseFloat(itemRegularPrice)
        )
          .toFixed(2)
          .replace(/\.00$/, "");
        var totalSalePrice = (
          parseFloat(currentSalePrice) + parseFloat(itemSalePrice)
        )
          .toFixed(2)
          .replace(/\.00$/, "");
      }
      if (type == "minus") {
        var totalRegPrice = (
          parseFloat(currentRegPrice) - parseFloat(itemRegularPrice)
        )
          .toFixed(2)
          .replace(/\.00$/, "");
        var totalSalePrice = (
          parseFloat(currentSalePrice) - parseFloat(itemSalePrice)
        )
          .toFixed(2)
          .replace(/\.00$/, "");
      }
      currentRegSec.innerHTML = `$${totalRegPrice}`;
      currentSaleSec.innerHTML = `$${totalSalePrice}`;
      productPrice.setAttribute("data-regularPrice", totalRegPrice);
      productPrice.setAttribute("data-salePrice", totalSalePrice);

      // if (totalRegPrice === totalSalePrice) {
      if (productPrice.getAttribute("data-regularprice") === productPrice.getAttribute("data-saleprice")) {
        totalPriceSection
          .querySelector(".renderPrice .price")
          .classList.remove("price--on-sale");
      }

      if (currentRegSecOnce) {
        currentRegSecOnce.innerHTML = `$${totalRegPrice}`;
      }
    }
  };

  updateClonePrice = () => {
    let pdpPwwtotalPriceCloneSection = document.querySelectorAll(
      ".pdpPww-total-price-clone__js"
    );

    if (pdpPwwtotalPriceCloneSection.length > 0) {
      pdpPwwtotalPriceCloneSection.forEach((pdpPwwtotalPriceClone) => {
        let pdpPwwtotalPrice = document.querySelector(
          ".pdpPww-total-price__js"
        );

        if (pdpPwwtotalPriceClone && pdpPwwtotalPrice != null) {
          pdpPwwtotalPriceClone.innerHTML = pdpPwwtotalPrice.innerHTML;
        }
        pdpPwwtotalPriceClone.querySelector("span.your-total-text").textContent = "Bundle Total:";
      });
    }
  };

  gtmTracking(e = null , type = null) {
    if( e == null )
      return false;
    let itemTitle = "bundleName";
    let eventName = "Clicked - PDP Bundle";
    let currentVariantTitle = "No bundle name Found";
    if(type == "add" || type == "remove"){
      if(type=="add")
        eventName = "Clicked - Added item to bundle";
      if(type=="remove")
        eventName = "Clicked - Removed item from bundle";
      itemTitle = "itemName";
      var actualEvent = e.target;
      currentVariantTitle = actualEvent.getAttribute("data-product-title");
    }
    else{
      var actualEvent = e.target;
      if(!e.target.classList.contains("js-bundle-select"))
          actualEvent = e.target.parentNode.parentNode;
      currentVariantTitle = actualEvent.getAttribute("data-bundle-name");
  }
    window.dataLayer.push({
      event: eventName
          ? eventName
          : "Clicked - PDP Bundle",
        itemTitle: currentVariantTitle
            ? currentVariantTitle
            : "No bundle name Found",
      pagePath: window.location.pathname,
      pageTitle: document.title,
    });
  }

  removeInputData(num) {
    let extraPrice = document.getElementById("product-extra-prices");
    let fieldAlreadyAdded = extraPrice.querySelector(
      `[name="items[${num}]id"]`
    );
    if (fieldAlreadyAdded) fieldAlreadyAdded.remove();
  }

  updateStickyATCInfo = () => {
    /**For price section*/
    let stickyBottomTotalPrice = document.getElementById(
      "stickyBottomTotalPrice"
    );
    let pdpPwwtotalPrice = document.querySelector(".pdpPww-total-price__js");
    if (stickyBottomTotalPrice != null && pdpPwwtotalPrice != null) {
      let pdpTotalPrice = pdpPwwtotalPrice.innerHTML;
      stickyBottomTotalPrice.innerHTML = pdpTotalPrice;
    }

    let productSelectedColorVariantLabel = document.querySelector(
      "variant-starts .color-swatch-variant .color-swatch-main-product input:checked ~ label"
    );
    let colorSwatchLabel = document.querySelector(
      ".sticky-atc .color-swatch-variant label"
    );
    if (colorSwatchLabel) {
      if (productSelectedColorVariantLabel) {
        let clonedVariantLabel =
          productSelectedColorVariantLabel.cloneNode(true);
        colorSwatchLabel.replaceWith(clonedVariantLabel);
      } else {
        colorSwatchLabel.classList.add("d-none");
      }
    }

    let colorSwatch = document.querySelector(
      ".sticky-atc .color-swatch-variant > span"
    );
    let productSelectedColorVariant = document.querySelector(
      "variant-starts .color-swatch-variant .selected"
    );
    let productSelectedDropdownVariantLabel = document.querySelector(
      "variant-starts .js-mainProductDropdownVariant select"
    );

    if (productSelectedColorVariant) {
      colorSwatch.innerHTML = productSelectedColorVariant.innerHTML;
    } else if (productSelectedDropdownVariantLabel) {
      colorSwatch.innerHTML = productSelectedDropdownVariantLabel.value;
    }
  };

  updateSavingAmount() {
    var totalPriceSection = document.querySelector(".pdpPww-total-price__js");
    var totalRegPrice = parseFloat(totalPriceSection.querySelector(
      ".price__sale .price-item--regular"
    ).innerHTML.replace("$", ""));
    var totalSalePrice = parseFloat(totalPriceSection.querySelector(
      ".price__sale .price-item--sale"
    ).innerHTML.replace("$", ""));
    let priceSaved = document.querySelectorAll(".price-saved-badge-wrapper .price-saved-badge");

    if(totalSalePrice < totalRegPrice){
      let calculatedSaving = (parseFloat(totalRegPrice) - parseFloat(totalSalePrice))
                                .toFixed(2)
                                .replace(/\.00$/, "");
      let priceSaveBadge = "$"+calculatedSaving+" Savings";

      priceSaved.forEach( (savedPrice) => {
        if(savedPrice.classList.contains('d-none'))
          savedPrice.classList.remove('d-none');
        savedPrice.innerHTML = priceSaveBadge;
      });
    }
    else{
      priceSaved.forEach( (savedPrice) => {
        if(!savedPrice.classList.contains('d-none'))
          savedPrice.classList.add('d-none');
        savedPrice.innerHTML = "";
      });
    }
  }

  updateCustomizationClass = () => {
    if (this.isCustomized()) {
      document.querySelector("bundled-product").classList.add("is-customized");
    } else {
      document.querySelector("bundled-product").classList.remove("is-customized");
    }
  }

  isCustomized = () => {
    let bundleVariant = document.querySelectorAll("input[name='Bundles']");
    let selectedBundle = "";

    bundleVariant.forEach((bvariant) => {
        if (bvariant.checked || bvariant.hasAttribute("checked")) {
            selectedBundle = bvariant.value;
        }
    });

    if (!selectedBundle) return false;

    let yourSelectedBundle = document.querySelectorAll(".js-bundle-items .pdp_bundle");
    if(yourSelectedBundle.length<1)
      return false;

    let mirrorBundle = document.querySelector("[data-mirror-bundle='" + selectedBundle + "']");
    if (!mirrorBundle) return false;

    let mbItems = mirrorBundle.querySelectorAll(".bundle-items .pdp_bundle");


    if (mbItems.length != yourSelectedBundle.length) {
        return true;
    }

    let similarItemCount = 0;

    mbItems.forEach((pdpItem) => {
        let bundleItemName = pdpItem.getAttribute("data-url");

        yourSelectedBundle.forEach((ysb) => {
            if (ysb.getAttribute("data-url") == bundleItemName) {
                similarItemCount += 1;
            }
        });
    });

    if (similarItemCount != yourSelectedBundle.length) {
        return true;
    }

    return false;
  };

  addProductToStickyATC = () => {
    let atcHolder = document.querySelector("#selectedBundleItems");
    if (!atcHolder) return;
    let selecteditems = document.querySelectorAll(
      ".js-bundle-items .pdp_bundle"
    );
    atcHolder.innerHTML = "";
    var imageCount = 0;

    selecteditems.forEach((item) => {
      let selectedItemImage = item.querySelectorAll("img");
      let selectedImage = "";
      let variantID = "";

      selectedItemImage.forEach((imgs) => {
        if (
          imgs.classList.contains("show") ||
          !imgs.classList.contains("d-none")
        ) {
          imgs.className = "";
          variantID = imgs.getAttribute("data-variant-id");
          selectedImage = imgs.cloneNode(true);
        }
      });

      if (selectedImage && atcHolder && variantID) {
        if (imageCount < 4) {
          const wrapper = document.createElement("div");
          wrapper.className = "sticky-atc-img";
          wrapper.setAttribute("data-variant-id", variantID);
          wrapper.appendChild(selectedImage);
          atcHolder.appendChild(wrapper);
        }
        imageCount++;
      }
    });

    if (imageCount > 4) {
      const moreButton = document.createElement("a");
      moreButton.setAttribute("tabindex", "0");
      moreButton.setAttribute("role", "button");
      moreButton.className = "more-button";
      moreButton.setAttribute("aria-label", "Click to View Bundle");
      moreButton.innerHTML = "+" + (imageCount - 4);
      atcHolder.appendChild(moreButton);
    }
  };

  updateCustomizedItems = (handle = "", display = false) => {
    const customizeAdons = document.querySelector(".js-adons-items");
    const adonItems = customizeAdons.querySelectorAll(".pdp_bundle");
    if (handle) {
      adonItems.forEach((adon) => {
        const adonItem = adon.getAttribute("data-url");
        if (handle == adonItem && display === false) {
          adon.classList.remove("js-bundle-items--full");
          adon.classList.add("js-bundle-items--transition");
          adon.classList.add("d-none");
        }

        if (handle == adonItem && display === true) {
          adon.classList.remove("js-bundle-items--full");
          adon.classList.remove("d-none");
          adon.classList.remove("js-bundle-items--transition");
        }
      });
    } else {
      const bundles = document.querySelector(".js-bundle-items");
      const bundleItems = bundles.querySelectorAll(".pdp_bundle");
      bundleItems.forEach((item) => {
        const itemHandleInBundle = item.getAttribute("data-url");

        adonItems.forEach((adon) => {
          const adonItem = adon.getAttribute("data-url");
          if (itemHandleInBundle == adonItem) {
            adon.classList.add("js-bundle-items--transition");
            adon.classList.add("d-none");
          }
        });
      });
    }
    var itemCount = 0;
    if (adonItems.length > 0) {
      adonItems.forEach((ait) => {
        if (!ait.classList.contains("d-none")) itemCount = itemCount + 1;
      });
    }

    if (itemCount == 0)
      document.querySelector(".customizer")?.classList.add("d-none");
    else document.querySelector(".customizer")?.classList.remove("d-none");
  };

  //not needed
  updateCustomizedItems_new = (handle = "", display = false) => {
    if (handle) {
      const customizeAdons = document.querySelector(".js-adons-items");
      const adonItems = customizeAdons.querySelectorAll(".pdp_bundle");
      adonItems.forEach((adon) => {
        const adonItem = adon.getAttribute("data-url");
        if (handle == adonItem && display === false) {
          adon.classList.remove("js-bundle-items--full");
          adon.classList.add("js-bundle-items--transition");
          adon.classList.add("d-none");
        }

        if (handle == adonItem && display === true) {
          adon.classList.remove("js-bundle-items--full");
          adon.classList.remove("d-none");
          adon.classList.remove("js-bundle-items--transition");
        }
      });
    } else {
      const bundles = document.querySelector(".js-bundle-items");
      const bundleItems = bundles.querySelectorAll(".pdp_bundle");
      bundleItems.forEach((item) => {
        const itemHandleInBundle = item.getAttribute("data-url");
        const customizeAdons = document.querySelector(".js-adons-items");
        const adonItems = customizeAdons.querySelectorAll(".pdp_bundle");
        adonItems.forEach((adon) => {
          const adonItem = adon.getAttribute("data-url");
          if (itemHandleInBundle == adonItem) {
            adon.classList.add("js-bundle-items--transition");
              adon.classList.add("d-none");
          }
        });
      });
    }
    const allCustomeitem = document.querySelectorAll(
      ".js-adons-items .pdp_bundle"
    );
    var itemCount = 0;

    if (allCustomeitem.length > 0) {
      allCustomeitem.forEach((ait) => {
        if (!ait.classList.contains("d-none")) itemCount = itemCount + 1;
      });
    }

    if (itemCount == 0)
      document.querySelector(".customizer")?.classList.add("d-none");
    else document.querySelector(".customizer")?.classList.remove("d-none");
  };

  updateAddtoCartList = (pitem) => {
    const itemValues = pitem.querySelector(
      '.checked[data-id="product-pdp_bundle"]'
    );
    var itemVariantID = "";
    const varitantImages = pitem.querySelectorAll(
      ".thumb-product-card-images img"
    );
    varitantImages.forEach((imgs) => {
      if (imgs.classList.contains("show") || !imgs.classList.contains("d-none"))
        itemVariantID = imgs.getAttribute("data-variant-id");
    });
    this.createInputData(
      itemValues.getAttribute("data-index"),
      itemVariantID,
      null
    );

    this.updateAdOnsItems();
    this.pdpPwwPriceUpdate(itemValues, "plus");
    this.updateClonePrice();
    this.updateSavingAmount();
    if (document.querySelector(".sticky-atc")) {
      this.updateStickyATCInfo();
    }
  };

  //To create item input fields in add to cart form
  createInputData(num, value, qty) {
    let extraPrice = document.getElementById("product-extra-prices");
    let fieldAlreadyAdded = extraPrice.querySelector(
      `[name="items[${num}]id"]`
    );
    let fieldQty = extraPrice.querySelector(`[name="items[${num}]quantity"]`);
    if (!fieldAlreadyAdded) {
      var x = document.createElement("INPUT");
      x.setAttribute("type", "hidden");
      x.setAttribute("name", `items[${num}]id`);
      x.setAttribute("value", value);
      // return x;
      extraPrice.appendChild(x);
    }
    if (!fieldQty && qty != null) {
      var x = document.createElement("INPUT");
      x.setAttribute("type", "hidden");
      x.setAttribute("name", `items[${num}]quantity`);
      x.setAttribute("value", qty);
      extraPrice.appendChild(x);
    }
  }

  //end
}
customElements.define("action-button", ActionButton);
